{
  "level": "mt02g",
  "source": {
    "spawn": "DERIVED_FROM_TREES_BBOX:mt02g",
    "objects": "AREAS.E3:mt02g.e3",
    "mesh": "TREES.E3:mt02g.e3"
  },
  "spawn_point": {
    "position": [
      -1442.3742552165743,
      -3359.710153159612,
      684.3853149414062
    ],
    "facing_rad": 0.0,
    "look_point": [
      -1442.3742552165743,
      -3259.710153159612,
      684.3853149414062
    ],
    "forward": [
      0.0,
      1.0,
      0.0
    ],
    "up": [
      0.0,
      0.0,
      1.0
    ],
    "derived": true
  },
  "mesh_point_cloud": {
    "note": "Raw vertex positions from TREES.E3.",
    "bbox_min": [
      -2230.8291015625,
      -3670.5068359375,
      660.3853149414062
    ],
    "bbox_max": [
      -345.5777587890625,
      -2699.56005859375,
      1534.9000244140625
    ],
    "vertex_count": 395,
    "vertices": [
      [
        -1124.3956298828125,
        -3441.16357421875,
        963.5977172851562
      ],
      [
        -1111.5189208984375,
        -3486.007568359375,
        1027.82666015625
      ],
      [
        -1131.9222412109375,
        -3494.98193359375,
        673.797607421875
      ],
      [
        -345.5777587890625,
        -3331.0029296875,
        1534.9000244140625
      ],
      [
        -883.3576049804688,
        -3646.800048828125,
        1435.7657470703125
      ],
      [
        -848.9866943359375,
        -3670.5068359375,
        1496.625244140625
      ],
      [
        -956.1067504882812,
        -3592.844970703125,
        1302.5999755859375
      ],
      [
        -1018.3594360351562,
        -3552.330810546875,
        1195.1632080078125
      ],
      [
        -1135.3389892578125,
        -3368.7138671875,
        869.4544067382812
      ],
      [
        -1124.3956298828125,
        -3441.16357421875,
        963.5977172851562
      ],
      [
        -1154.92236328125,
        -3322.028076171875,
        796.5574951171875
      ],
      [
        -1147.365966796875,
        -3348.469482421875,
        834.3935546875
      ],
      [
        -1147.365966796875,
        -3348.469482421875,
        834.3935546875
      ],
      [
        -1135.3389892578125,
        -3368.7138671875,
        869.4544677734375
      ],
      [
        -1162.9578857421875,
        -3326.628662109375,
        708.9635620117188
      ],
      [
        -1154.92236328125,
        -3322.028076171875,
        796.5574951171875
      ],
      [
        -1163.844970703125,
        -3319.947509765625,
        715.8609619140625
      ],
      [
        -1160.2471923828125,
        -3316.307861328125,
        784.7702026367188
      ],
      [
        -883.3576049804688,
        -3646.800048828125,
        1435.765869140625
      ],
      [
        -956.1067504882812,
        -3592.844970703125,
        1302.5999755859375
      ],
      [
        -1133.9759521484375,
        -3494.23974609375,
        660.3853149414062
      ],
      [
        -1131.9222412109375,
        -3494.98193359375,
        673.797607421875
      ],
      [
        -1182.1806640625,
        -3293.62548828125,
        729.0673217773438
      ],
      [
        -1180.3018798828125,
        -3294.763427734375,
        740.3759155273438
      ],
      [
        -1184.6175537109375,
        -3290.127197265625,
        730.822509765625
      ],
      [
        -1005.9225463867188,
        -3266.954345703125,
        918.49560546875
      ],
      [
        -1124.5316162109375,
        -3388.79541015625,
        971.9288330078125
      ],
      [
        -877.6963500976562,
        -3646.800048828125,
        1490.475341796875
      ],
      [
        -985.8045043945312,
        -3565.672607421875,
        1302.5999755859375
      ],
      [
        -1111.7132568359375,
        -3461.161865234375,
        1071.447998046875
      ],
      [
        -1109.9140625,
        -3472.537353515625,
        1086.9161376953125
      ],
      [
        -1111.1741943359375,
        -3472.395751953125,
        1076.2362060546875
      ],
      [
        -1111.1741943359375,
        -3472.395751953125,
        1076.2362060546875
      ],
      [
        -1114.5927734375,
        -3475.302490234375,
        1012.494140625
      ],
      [
        -877.6963500976562,
        -3646.800048828125,
        1490.475341796875
      ],
      [
        -861.835205078125,
        -3657.87451171875,
        1517.0201416015625
      ],
      [
        -1124.5316162109375,
        -3388.79541015625,
        971.9288330078125
      ],
      [
        -1111.7132568359375,
        -3461.161865234375,
        1071.447998046875
      ],
      [
        -1138.5511474609375,
        -3363.30712890625,
        860.0905151367188
      ],
      [
        -985.8045043945312,
        -3565.672607421875,
        1302.5999755859375
      ],
      [
        -1091.0789794921875,
        -3495.659912109375,
        1130.713134765625
      ],
      [
        -1109.1981201171875,
        -3477.0634765625,
        1093.070556640625
      ],
      [
        -1107.164794921875,
        -3484.092529296875,
        1103.378662109375
      ],
      [
        -1109.1981201171875,
        -3477.0634765625,
        1093.070556640625
      ],
      [
        -1154.881103515625,
        -3314.75439453125,
        856.0769653320312
      ],
      [
        -1206.0413818359375,
        -3259.3720703125,
        746.2530517578125
      ],
      [
        -1126.0,
        -3322.0,
        888.5076904296875
      ],
      [
        -1148.606689453125,
        -3322.0,
        865.8651733398438
      ],
      [
        -1148.18798828125,
        -3322.0,
        870.4451904296875
      ],
      [
        -1136.6383056640625,
        -3320.219482421875,
        877.655517578125
      ],
      [
        -1135.1929931640625,
        -3322.0,
        877.9910278320312
      ],
      [
        -1149.4361572265625,
        -3322.0,
        856.7926025390625
      ],
      [
        -1154.881103515625,
        -3314.75439453125,
        856.0769653320312
      ],
      [
        -1146.776123046875,
        -3314.0,
        861.7461547851562
      ],
      [
        -1147.9173583984375,
        -3316.840576171875,
        864.31396484375
      ],
      [
        -1146.5098876953125,
        -3322.0,
        861.1472778320312
      ],
      [
        -1149.4439697265625,
        -3320.640380859375,
        867.7490234375
      ],
      [
        -1148.606689453125,
        -3322.0,
        865.8651733398438
      ],
      [
        -1134.77587890625,
        -3321.42529296875,
        880.6557006835938
      ],
      [
        -1134.612548828125,
        -3322.0,
        879.8124389648438
      ],
      [
        -1135.193115234375,
        -3322.0,
        877.9910278320312
      ],
      [
        -1136.6383056640625,
        -3320.2197265625,
        877.655517578125
      ],
      [
        -1134.300048828125,
        -3339.750732421875,
        878.1983032226562
      ],
      [
        -1149.990234375,
        -3322.0,
        868.9780883789062
      ],
      [
        -1149.990234375,
        -3322.0,
        868.9780883789062
      ],
      [
        -695.2380981445312,
        -2699.56005859375,
        1534.9000244140625
      ],
      [
        -753.2095336914062,
        -2930.939453125,
        1302.5999755859375
      ],
      [
        -928.2139282226562,
        -3044.112548828125,
        860.7633666992188
      ],
      [
        -839.289306640625,
        -3015.74853515625,
        995.389404296875
      ],
      [
        -839.289306640625,
        -3015.74853515625,
        995.389404296875
      ],
      [
        -824.54638671875,
        -3012.109619140625,
        1008.571044921875
      ],
      [
        -1314.5831298828125,
        -3102.529052734375,
        832.7566528320312
      ],
      [
        -1314.62060546875,
        -3103.500244140625,
        824.4575805664062
      ],
      [
        -919.8650512695312,
        -3044.44287109375,
        863.2476806640625
      ],
      [
        -839.7464599609375,
        -3021.233642578125,
        975.5206909179688
      ],
      [
        -839.7464599609375,
        -3021.233642578125,
        975.5206909179688
      ],
      [
        -830.856201171875,
        -3019.2890625,
        982.5640258789062
      ],
      [
        -1169.45703125,
        -3298.9755859375,
        824.7872314453125
      ],
      [
        -1042.8544921875,
        -3356.1904296875,
        1087.07763671875
      ],
      [
        -1088.26025390625,
        -3351.53564453125,
        955.588623046875
      ],
      [
        -1126.0,
        -3322.0,
        906.8359375
      ],
      [
        -1133.8880615234375,
        -3322.0,
        882.0863037109375
      ],
      [
        -1478.322509765625,
        -3155.73876953125,
        1302.5999755859375
      ],
      [
        -1474.7017822265625,
        -3159.5546875,
        1292.3797607421875
      ],
      [
        -1325.873046875,
        -3087.09765625,
        833.7279663085938
      ],
      [
        -1325.9395751953125,
        -3087.1298828125,
        833.595947265625
      ],
      [
        -1325.9395751953125,
        -3087.1298828125,
        833.595947265625
      ],
      [
        -1325.9541015625,
        -3087.136962890625,
        833.381103515625
      ],
      [
        -1365.056396484375,
        -3275.11376953125,
        982.8839111328125
      ],
      [
        -1187.63818359375,
        -3271.1650390625,
        851.7719116210938
      ],
      [
        -1181.72705078125,
        -3282.366455078125,
        825.4610595703125
      ],
      [
        -1183.9248046875,
        -3261.96630859375,
        866.6787719726562
      ],
      [
        -1187.63818359375,
        -3271.1650390625,
        851.7719116210938
      ],
      [
        -1108.9974365234375,
        -3472.640380859375,
        1094.684326171875
      ],
      [
        -1108.9974365234375,
        -3472.640380859375,
        1094.684326171875
      ],
      [
        -1109.9140625,
        -3472.537353515625,
        1086.9161376953125
      ],
      [
        -1148.692138671875,
        -3314.0,
        866.0571899414062
      ],
      [
        -1147.9173583984375,
        -3316.840576171875,
        864.3139038085938
      ],
      [
        -1108.4205322265625,
        -3479.75146484375,
        1097.012451171875
      ],
      [
        -1487.869140625,
        -3159.594970703125,
        1302.5999755859375
      ],
      [
        -1358.6834716796875,
        -3295.425048828125,
        938.5732421875
      ],
      [
        -2230.8291015625,
        -3270.034423828125,
        1419.850830078125
      ],
      [
        -2132.0,
        -3288.776123046875,
        1329.7178955078125
      ],
      [
        -1906.34521484375,
        -3336.720703125,
        1050.3902587890625
      ],
      [
        -1920.9259033203125,
        -3372.69189453125,
        986.3633422851562
      ],
      [
        -1851.0653076171875,
        -3353.709716796875,
        969.5125122070312
      ],
      [
        -1851.142333984375,
        -3353.674072265625,
        969.6503295898438
      ],
      [
        -1899.3868408203125,
        -3366.89013671875,
        981.060791015625
      ],
      [
        -1851.0653076171875,
        -3353.709716796875,
        969.5125122070312
      ],
      [
        -1920.9259033203125,
        -3372.69189453125,
        986.3633422851562
      ],
      [
        -1899.3868408203125,
        -3366.89013671875,
        981.060791015625
      ],
      [
        -1877.360107421875,
        -3341.549560546875,
        1016.5908813476562
      ],
      [
        -1906.34521484375,
        -3336.720703125,
        1050.3902587890625
      ],
      [
        -1877.360107421875,
        -3341.549560546875,
        1016.5908813476562
      ],
      [
        -2132.0,
        -3288.776123046875,
        1329.7178955078125
      ],
      [
        -2118.65673828125,
        -3291.368896484375,
        1318.740234375
      ],
      [
        -2117.939453125,
        -3291.50830078125,
        1318.150146484375
      ],
      [
        -1990.029052734375,
        -3315.35791015625,
        1193.728759765625
      ],
      [
        -2099.03857421875,
        -3295.18115234375,
        1302.5999755859375
      ],
      [
        -1990.029052734375,
        -3315.35791015625,
        1193.728759765625
      ],
      [
        -1908.0928955078125,
        -3328.522216796875,
        1073.7103271484375
      ],
      [
        -2099.03857421875,
        -3295.18115234375,
        1302.5999755859375
      ],
      [
        -1963.5389404296875,
        -3397.61865234375,
        997.9432983398438
      ],
      [
        -1893.4989013671875,
        -3386.22607421875,
        981.30615234375
      ],
      [
        -1805.2481689453125,
        -3346.929931640625,
        959.013916015625
      ],
      [
        -1760.14404296875,
        -3357.16748046875,
        950.01318359375
      ],
      [
        -1797.066650390625,
        -3370.23291015625,
        959.073486328125
      ],
      [
        -1797.066650390625,
        -3370.23291015625,
        959.073486328125
      ],
      [
        -1760.14404296875,
        -3357.16748046875,
        950.01318359375
      ],
      [
        -1742.0198974609375,
        -3361.262451171875,
        946.0342407226562
      ],
      [
        -1963.5389404296875,
        -3397.61865234375,
        997.9432983398438
      ],
      [
        -1893.4989013671875,
        -3386.22607421875,
        981.30615234375
      ],
      [
        -1805.2481689453125,
        -3346.929931640625,
        959.013916015625
      ],
      [
        -1851.142333984375,
        -3353.674072265625,
        969.6503295898438
      ],
      [
        -1805.5211181640625,
        -3346.88037109375,
        959.3063354492188
      ],
      [
        -1869.69921875,
        -3335.24560546875,
        1028.0589599609375
      ],
      [
        -1869.69921875,
        -3335.24560546875,
        1028.0589599609375
      ],
      [
        -1908.0928955078125,
        -3328.522216796875,
        1073.7103271484375
      ],
      [
        -1668.906982421875,
        -3378.801025390625,
        949.4402465820312
      ],
      [
        -1688.38671875,
        -3373.380126953125,
        934.2597045898438
      ],
      [
        -1821.7552490234375,
        -3378.96923828125,
        965.1317138671875
      ],
      [
        -1694.455322265625,
        -3372.009033203125,
        935.5919799804688
      ],
      [
        -1999.3497314453125,
        -3418.56640625,
        1007.6747436523438
      ],
      [
        -2077.546630859375,
        -3442.896240234375,
        1026.71435546875
      ],
      [
        -1494.023193359375,
        -3426.5,
        892.0
      ],
      [
        -1594.19287109375,
        -3426.5,
        915.0
      ],
      [
        -1624.5,
        -3441.5,
        922.6275634765625
      ],
      [
        -1624.5,
        -3426.5,
        921.9588012695312
      ],
      [
        -1610.0,
        -3441.5,
        919.2982177734375
      ],
      [
        -1624.5,
        -3441.5,
        922.6275634765625
      ],
      [
        -1518.5125732421875,
        -3411.5,
        892.0
      ],
      [
        -1495.892822265625,
        -3416.870849609375,
        892.0
      ],
      [
        -1494.023193359375,
        -3426.5,
        892.0
      ],
      [
        -1999.3497314453125,
        -3418.56640625,
        1007.6747436523438
      ],
      [
        -1597.1053466796875,
        -3411.5,
        915.0
      ],
      [
        -1519.66455078125,
        -3411.5,
        897.2188110351562
      ],
      [
        -1518.5125732421875,
        -3411.5,
        892.0
      ],
      [
        -2097.268310546875,
        -3420.75,
        1028.596923828125
      ],
      [
        -2096.970458984375,
        -3421.255859375,
        1028.586181640625
      ],
      [
        -1594.19287109375,
        -3426.5,
        915.0
      ],
      [
        -1597.1053466796875,
        -3411.5,
        915.0
      ],
      [
        -1861.920166015625,
        -3380.98876953125,
        974.025634765625
      ],
      [
        -1821.7552490234375,
        -3378.96923828125,
        965.1317138671875
      ],
      [
        -2097.664794921875,
        -3420.08837890625,
        1030.3167724609375
      ],
      [
        -2096.9150390625,
        -3421.361083984375,
        1030.201416015625
      ],
      [
        -1480.912109375,
        -3426.5,
        892.0
      ],
      [
        -1583.42529296875,
        -3426.5,
        915.0
      ],
      [
        -2012.912353515625,
        -3426.5,
        1011.3603515625
      ],
      [
        -2024.8485107421875,
        -3426.5,
        1013.88330078125
      ],
      [
        -1624.5,
        -3441.5,
        925.4306640625
      ],
      [
        -1624.5,
        -3426.5,
        924.215576171875
      ],
      [
        -1610.0,
        -3441.5,
        922.1774291992188
      ],
      [
        -1624.5,
        -3441.5,
        925.4306640625
      ],
      [
        -1588.841064453125,
        -3411.5,
        915.0
      ],
      [
        -1520.1895751953125,
        -3411.5,
        899.5972900390625
      ],
      [
        -1583.42529296875,
        -3426.5,
        915.0
      ],
      [
        -1588.841064453125,
        -3411.5,
        915.0
      ],
      [
        -1483.3101806640625,
        -3419.858642578125,
        892.0
      ],
      [
        -1480.912109375,
        -3426.5,
        892.0
      ],
      [
        -1455.339599609375,
        -3426.5,
        892.0
      ],
      [
        -1460.416748046875,
        -3426.5,
        915.0
      ],
      [
        -1460.416748046875,
        -3426.5,
        915.0
      ],
      [
        -1523.589599609375,
        -3411.5,
        915.0
      ],
      [
        -2099.403076171875,
        -3417.519287109375,
        1086.0
      ],
      [
        -2105.126953125,
        -3407.63330078125,
        1062.69677734375
      ],
      [
        -1523.589599609375,
        -3411.5,
        915.0
      ],
      [
        -1455.339599609375,
        -3426.5,
        892.0
      ],
      [
        -1621.5601806640625,
        -3400.1845703125,
        1142.920654296875
      ],
      [
        -1621.5601806640625,
        -3400.1845703125,
        1142.920654296875
      ],
      [
        -1649.380126953125,
        -3395.459716796875,
        1178.8031005859375
      ],
      [
        -1951.966796875,
        -3140.44775390625,
        1490.3951416015625
      ],
      [
        -1827.3253173828125,
        -3163.619384765625,
        1395.6365966796875
      ],
      [
        -1356.0,
        -3316.649169921875,
        860.0
      ],
      [
        -1356.0,
        -3315.0,
        864.300537109375
      ],
      [
        -1827.325927734375,
        -3163.61962890625,
        1395.635986328125
      ],
      [
        -1454.6273193359375,
        -3194.546630859375,
        1208.92919921875
      ],
      [
        -1700.1697998046875,
        -3195.74658203125,
        1281.837890625
      ],
      [
        -1701.595703125,
        -3187.230224609375,
        1304.4864501953125
      ],
      [
        -1836.784912109375,
        -3171.775634765625,
        1386.64892578125
      ],
      [
        -1948.3681640625,
        -3154.940185546875,
        1465.1025390625
      ],
      [
        -1836.784912109375,
        -3171.77587890625,
        1386.64892578125
      ],
      [
        -1698.49169921875,
        -3187.5849609375,
        1302.5999755859375
      ],
      [
        -1700.169921875,
        -3195.74658203125,
        1281.837890625
      ],
      [
        -1698.49169921875,
        -3187.5849609375,
        1302.5999755859375
      ],
      [
        -1356.0,
        -3323.0,
        878.486083984375
      ],
      [
        -1356.0,
        -3315.0,
        898.5741577148438
      ],
      [
        -1356.0,
        -3316.654541015625,
        895.3707885742188
      ],
      [
        -1333.5452880859375,
        -3323.0,
        865.5230712890625
      ],
      [
        -1356.0,
        -3323.0,
        878.486083984375
      ],
      [
        -1350.0927734375,
        -3323.0,
        878.4644775390625
      ],
      [
        -1335.0635986328125,
        -3323.0,
        878.4094848632812
      ],
      [
        -1356.0,
        -3315.0,
        899.7730712890625
      ],
      [
        -2135.1669921875,
        -3259.64013671875,
        1382.73095703125
      ],
      [
        -1971.04541015625,
        -3232.9873046875,
        1351.1773681640625
      ],
      [
        -1929.8310546875,
        -3229.592529296875,
        1334.817626953125
      ],
      [
        -1897.7880859375,
        -3224.376220703125,
        1328.6890869140625
      ],
      [
        -1897.7884521484375,
        -3224.37646484375,
        1328.6888427734375
      ],
      [
        -1723.06787109375,
        -3184.775634765625,
        1317.536376953125
      ],
      [
        -1775.80810546875,
        -3201.28125,
        1313.641357421875
      ],
      [
        -2224.197509765625,
        -3262.831787109375,
        1428.6636962890625
      ],
      [
        -2135.1669921875,
        -3259.64013671875,
        1382.73095703125
      ],
      [
        -1701.595703125,
        -3187.230224609375,
        1304.4864501953125
      ],
      [
        -2104.0859375,
        -3294.200439453125,
        1306.75244140625
      ],
      [
        -1561.8681640625,
        -3380.0,
        1485.0
      ],
      [
        -1587.9073486328125,
        -3337.847900390625,
        1485.0
      ],
      [
        -1627.0,
        -3340.10986328125,
        1485.0
      ],
      [
        -1538.0,
        -3418.6376953125,
        1485.0
      ],
      [
        -1538.0,
        -3420.196533203125,
        1505.0
      ],
      [
        -1538.0,
        -3418.6376953125,
        1485.0
      ],
      [
        -1538.0,
        -3416.611572265625,
        1459.0
      ],
      [
        -1631.884765625,
        -3366.351806640625,
        1318.4051513671875
      ],
      [
        -1590.7506103515625,
        -3333.2451171875,
        1485.0
      ],
      [
        -1627.0,
        -3333.9482421875,
        1485.0
      ],
      [
        -1542.2615966796875,
        -3366.172119140625,
        900.3104248046875
      ],
      [
        -1514.9678955078125,
        -3411.5,
        915.0
      ],
      [
        -1513.8607177734375,
        -3411.5,
        892.0
      ],
      [
        -1694.455078125,
        -3372.009033203125,
        935.5919189453125
      ],
      [
        -1514.9678955078125,
        -3411.5,
        915.0
      ],
      [
        -1513.48583984375,
        -3413.899169921875,
        915.0
      ],
      [
        -1513.8607177734375,
        -3411.5,
        892.0
      ],
      [
        -1513.06103515625,
        -3412.79443359375,
        892.0
      ],
      [
        -1696.3232421875,
        -3371.5869140625,
        936.0020751953125
      ],
      [
        -1557.1119384765625,
        -3342.439697265625,
        904.253662109375
      ],
      [
        -1542.2615966796875,
        -3366.172119140625,
        900.3104248046875
      ],
      [
        -1568.4244384765625,
        -3324.258544921875,
        905.9407348632812
      ],
      [
        -1557.1119384765625,
        -3342.439697265625,
        904.253662109375
      ],
      [
        -1607.613037109375,
        -3293.278564453125,
        1322.4322509765625
      ],
      [
        -1593.99072265625,
        -3328.0,
        1485.0
      ],
      [
        -1385.80908203125,
        -3411.5,
        915.0
      ],
      [
        -1381.0543212890625,
        -3411.5,
        911.31005859375
      ],
      [
        -1381.0543212890625,
        -3411.5,
        911.31005859375
      ],
      [
        -1380.0,
        -3411.5,
        910.4920043945312
      ],
      [
        -1370.0,
        -3407.306640625,
        894.0
      ],
      [
        -1373.0,
        -3406.18896484375,
        894.0
      ],
      [
        -1405.0,
        -3394.263916015625,
        894.0
      ],
      [
        -1401.5,
        -3395.568115234375,
        894.0
      ],
      [
        -1375.0,
        -3405.443603515625,
        894.0
      ],
      [
        -1399.5,
        -3396.313720703125,
        894.0
      ],
      [
        -1401.5,
        -3395.568115234375,
        894.0
      ],
      [
        -1401.5,
        -3405.65283203125,
        915.0
      ],
      [
        -1399.5,
        -3406.398193359375,
        915.0
      ],
      [
        -1399.5,
        -3396.313720703125,
        894.0
      ],
      [
        -1401.5,
        -3405.65283203125,
        915.0
      ],
      [
        -1399.5,
        -3407.23828125,
        916.75
      ],
      [
        -1399.5,
        -3410.0,
        916.75
      ],
      [
        -1375.0,
        -3410.0,
        903.48828125
      ],
      [
        -1381.4818115234375,
        -3410.0,
        908.5182495117188
      ],
      [
        -1381.4818115234375,
        -3410.0,
        908.5182495117188
      ],
      [
        -1389.83447265625,
        -3410.0,
        915.0
      ],
      [
        -1389.83447265625,
        -3410.0,
        915.0
      ],
      [
        -1392.41162109375,
        -3410.0,
        917.0
      ],
      [
        -1375.0,
        -3405.443603515625,
        894.0
      ],
      [
        -1375.0,
        -3410.0,
        903.48828125
      ],
      [
        -1373.0,
        -3410.0,
        901.936279296875
      ],
      [
        -1373.0,
        -3406.18896484375,
        894.0
      ],
      [
        -1396.5,
        -3397.725830078125,
        894.6129150390625
      ],
      [
        -1396.5,
        -3398.5,
        896.2250366210938
      ],
      [
        -1396.5,
        -3397.725830078125,
        894.6129150390625
      ],
      [
        -1396.5,
        -3397.431396484375,
        894.0
      ],
      [
        -1396.5,
        -3402.7138671875,
        905.0
      ],
      [
        -1396.5,
        -3403.674072265625,
        907.0
      ],
      [
        -1396.5,
        -3403.674072265625,
        907.0
      ],
      [
        -1399.5,
        -3403.5166015625,
        909.0
      ],
      [
        -1399.5,
        -3406.398193359375,
        915.0
      ],
      [
        -1397.5,
        -3408.103759765625,
        917.0
      ],
      [
        -1397.5,
        -3408.823974609375,
        918.5
      ],
      [
        -1397.5,
        -3408.103759765625,
        917.0
      ],
      [
        -1396.5,
        -3410.0,
        917.0
      ],
      [
        -1396.5,
        -3408.476318359375,
        917.0
      ],
      [
        -1399.0,
        -3401.7822265625,
        905.0
      ],
      [
        -1399.0,
        -3398.5,
        898.1651611328125
      ],
      [
        -1399.5,
        -3396.5,
        894.3884887695312
      ],
      [
        -1398.9993896484375,
        -3396.5,
        894.0
      ],
      [
        -1396.5,
        -3398.5,
        896.2250366210938
      ],
      [
        -1399.0,
        -3398.5,
        898.1651611328125
      ],
      [
        -1396.5,
        -3402.714111328125,
        905.0
      ],
      [
        -1399.0,
        -3401.7822265625,
        905.0
      ],
      [
        -1392.41162109375,
        -3410.0,
        917.0
      ],
      [
        -1380.0,
        -3413.664794921875,
        915.0
      ],
      [
        -1385.80908203125,
        -3411.5,
        915.0
      ],
      [
        -1380.0,
        -3411.5,
        910.4920043945312
      ],
      [
        -1380.0,
        -3413.664794921875,
        915.0
      ],
      [
        -1557.0653076171875,
        -3342.51416015625,
        904.2412719726562
      ],
      [
        -1565.24267578125,
        -3293.638427734375,
        1368.73681640625
      ],
      [
        -1553.3206787109375,
        -3334.5,
        1525.0
      ],
      [
        -1547.0,
        -3387.0,
        1485.0
      ],
      [
        -1547.0,
        -3387.0,
        1505.0
      ],
      [
        -1405.0,
        -3368.0,
        884.3970947265625
      ],
      [
        -1370.0,
        -3368.0,
        882.0144653320312
      ],
      [
        -1370.0,
        -3379.22998046875,
        894.0
      ],
      [
        -1373.0,
        -3379.038818359375,
        894.0
      ],
      [
        -1405.0,
        -3376.99755859375,
        894.0
      ],
      [
        -1401.5,
        -3377.220947265625,
        894.0
      ],
      [
        -1375.0,
        -3378.9111328125,
        894.0
      ],
      [
        -1399.5,
        -3377.348388671875,
        894.0
      ],
      [
        -1337.6041259765625,
        -3374.0,
        886.2127075195312
      ],
      [
        -1356.0,
        -3374.0,
        887.46484375
      ],
      [
        -1356.0,
        -3374.0,
        887.46484375
      ],
      [
        -1356.0,
        -3368.0,
        860.0
      ],
      [
        -1356.0,
        -3368.0,
        881.0611572265625
      ],
      [
        -1373.0,
        -3398.715087890625,
        915.0
      ],
      [
        -1373.0,
        -3379.038818359375,
        894.0
      ],
      [
        -1375.0,
        -3378.9111328125,
        894.0
      ],
      [
        -1375.0,
        -3398.58740234375,
        915.0
      ],
      [
        -1401.5,
        -3377.220947265625,
        894.0
      ],
      [
        -1401.5,
        -3396.897216796875,
        915.0
      ],
      [
        -1399.5,
        -3397.024658203125,
        915.0
      ],
      [
        -1399.5,
        -3377.348388671875,
        894.0
      ],
      [
        -1401.5,
        -3396.897216796875,
        915.0
      ],
      [
        -1399.5,
        -3398.66455078125,
        916.75
      ],
      [
        -1399.5,
        -3407.23828125,
        916.75
      ],
      [
        -1377.0,
        -3400.333740234375,
        917.0
      ],
      [
        -1397.5,
        -3399.02587890625,
        917.0
      ],
      [
        -1399.2142333984375,
        -3398.9169921875,
        917.0
      ],
      [
        -1397.5,
        -3400.431640625,
        918.5
      ],
      [
        -1399.2142333984375,
        -3407.46484375,
        917.0
      ],
      [
        -1399.5,
        -3401.5,
        915.0
      ],
      [
        -1399.5,
        -3403.5,
        915.0
      ],
      [
        -1397.5,
        -3403.5,
        917.0
      ],
      [
        -1397.5,
        -3401.5,
        917.0
      ],
      [
        -1399.2142333984375,
        -3401.5,
        917.0
      ],
      [
        -1399.2142333984375,
        -3403.5,
        917.0
      ],
      [
        -1399.5,
        -3403.5,
        916.75
      ],
      [
        -1399.5,
        -3401.5,
        916.75
      ],
      [
        -1375.0,
        -3403.5,
        915.0
      ],
      [
        -1375.0,
        -3401.5,
        915.0
      ],
      [
        -1377.0,
        -3401.5,
        917.0
      ],
      [
        -1377.0,
        -3403.5,
        917.0
      ],
      [
        -1399.5,
        -3397.024658203125,
        915.0
      ],
      [
        -1397.5,
        -3399.02587890625,
        917.0
      ],
      [
        -1375.0,
        -3398.58740234375,
        915.0
      ],
      [
        -1377.0,
        -3400.333740234375,
        917.0
      ],
      [
        -1376.0,
        -3388.685546875,
        904.5
      ],
      [
        -1379.0,
        -3398.332275390625,
        915.0
      ],
      [
        -1376.3701171875,
        -3398.5,
        915.0
      ],
      [
        -1375.0,
        -3398.5,
        914.9066772460938
      ],
      [
        -1376.0,
        -3388.685546875,
        904.5
      ],
      [
        -1375.0,
        -3388.749267578125,
        904.5
      ],
      [
        -1379.0,
        -3397.0,
        897.25
      ],
      [
        -1379.0,
        -3385.0,
        897.25
      ],
      [
        -1379.5999755859375,
        -3396.5,
        896.7999877929688
      ],
      [
        -1379.5999755859375,
        -3396.5,
        898.0
      ],
      [
        -1356.0,
        -3366.0,
        878.9266357421875
      ],
      [
        -1355.343994140625,
        -3323.0,
        878.4837036132812
      ],
      [
        -1356.0,
        -3323.0,
        878.5187377929688
      ],
      [
        -1356.0,
        -3323.0,
        878.5187377929688
      ],
      [
        -1356.0,
        -3322.98779296875,
        878.5187377929688
      ],
      [
        -1351.4473876953125,
        -3323.0,
        878.4694213867188
      ],
      [
        -1356.0,
        -3323.0,
        878.704833984375
      ],
      [
        -1356.0,
        -3323.0,
        878.704833984375
      ],
      [
        -1356.0,
        -3322.917724609375,
        878.7052001953125
      ],
      [
        -1340.1395263671875,
        -3374.0,
        894.0
      ],
      [
        -1356.0,
        -3374.0,
        894.0
      ],
      [
        -1356.0,
        -3374.0,
        894.0
      ],
      [
        -1356.0,
        -3368.0,
        881.0611572265625
      ],
      [
        -1356.0,
        -3368.0,
        894.0
      ],
      [
        -1399.2142333984375,
        -3374.5,
        917.0
      ],
      [
        -1399.2142333984375,
        -3398.9169921875,
        917.0
      ],
      [
        -1375.2857666015625,
        -3374.5,
        917.0
      ],
      [
        -1399.2142333984375,
        -3374.5,
        917.0
      ],
      [
        -1375.0,
        -3374.5,
        913.8333129882812
      ],
      [
        -1375.0,
        -3374.5,
        894.0
      ],
      [
        -1375.0,
        -3374.5,
        915.0
      ],
      [
        -1375.0,
        -3374.5,
        913.8333129882812
      ],
      [
        -1375.0,
        -3374.5,
        915.0
      ],
      [
        -1375.0,
        -3374.5,
        916.7499389648438
      ],
      [
        -1399.5,
        -3374.5,
        916.7499389648438
      ],
      [
        -1399.5,
        -3398.66455078125,
        916.7499389648438
      ],
      [
        -1399.5,
        -3374.5,
        912.8461303710938
      ],
      [
        -1399.5,
        -3374.5,
        894.0
      ],
      [
        -1399.5,
        -3374.5,
        915.0
      ],
      [
        -1399.5,
        -3374.5,
        912.8461303710938
      ],
      [
        -1399.5,
        -3374.5,
        915.0
      ],
      [
        -1399.5,
        -3374.5,
        916.7499389648438
      ],
      [
        -1356.0,
        -3368.0,
        912.0
      ]
    ]
  },
  "sectors": [
    {
      "plane_normal": [
        -0.6443679928779602,
        -0.762627899646759,
        0.0564676970243454
      ],
      "plane_d": -3432.79296875,
      "bbox_min": [
        -3260.67529296875,
        -3790.68359375,
        621.68359375
      ],
      "bbox_max": [
        -342.082275390625,
        -2690.8427734375,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4566386640071869,
        0.6905266642570496,
        0.5609403848648071
      ],
      "plane_d": 1281.354736328125,
      "bbox_min": [
        -1478.322509765625,
        -3790.68359375,
        621.68359375
      ],
      "bbox_max": [
        -342.082275390625,
        -2690.8427734375,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5389724969863892,
        0.6360949873924255,
        0.5521700382232666
      ],
      "plane_d": 1050.81884765625,
      "bbox_min": [
        -1206.0413818359375,
        -3790.68359375,
        621.68359375
      ],
      "bbox_max": [
        -342.082275390625,
        -3090.42138671875,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9792153239250183,
        -0.19332727789878845,
        0.061334479600191116
      ],
      "plane_d": -1825.3980712890625,
      "bbox_min": [
        -1184.6175537109375,
        -3790.68359375,
        621.68359375
      ],
      "bbox_max": [
        -342.082275390625,
        -3253.36376953125,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6707790493965149,
        -0.7331188917160034,
        0.11221480369567871
      ],
      "plane_d": -3421.490234375,
      "bbox_min": [
        -1163.844970703125,
        -3646.800048828125,
        708.9635620117188
      ],
      "bbox_max": [
        -883.3576049804688,
        -3316.307861328125,
        1435.765869140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9931049346923828,
        0.0022958379704505205,
        0.11720679700374603
      ],
      "plane_d": -1221.6827392578125,
      "bbox_min": [
        -1163.844970703125,
        -3441.16357421875,
        708.9635620117188
      ],
      "bbox_max": [
        -1124.3956298828125,
        -3316.307861328125,
        963.5977172851562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9845805764198303,
        -0.14805786311626434,
        0.09316641837358475
      ],
      "plane_d": -1703.1788330078125,
      "bbox_min": [
        -1163.844970703125,
        -3394.3984375,
        708.9635620117188
      ],
      "bbox_max": [
        -1135.3389892578125,
        -3316.307861328125,
        869.4544677734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9533829092979431,
        -0.23182019591331482,
        0.1931847333908081
      ],
      "plane_d": -2031.31396484375,
      "bbox_min": [
        -1147.365966796875,
        -3394.3984375,
        794.9396362304688
      ],
      "bbox_max": [
        -1135.3389892578125,
        -3348.469482421875,
        869.4544677734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9856189489364624,
        -0.10732632130384445,
        0.13052378594875336
      ],
      "plane_d": -1595.8048095703125,
      "bbox_min": [
        -1163.844970703125,
        -3394.3984375,
        708.9635620117188
      ],
      "bbox_max": [
        -1144.192626953125,
        -3316.307861328125,
        796.5574951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8007402420043945,
        -0.5945212841033936,
        0.073208749294281
      ],
      "plane_d": -2958.124267578125,
      "bbox_min": [
        -1163.844970703125,
        -3322.028076171875,
        715.0380249023438
      ],
      "bbox_max": [
        -1154.92236328125,
        -3316.307861328125,
        796.5574951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6734017729759216,
        -0.7359853386878967,
        0.06968268007040024
      ],
      "plane_d": -3378.893798828125,
      "bbox_min": [
        -956.1067504882812,
        -3646.800048828125,
        1302.5999755859375
      ],
      "bbox_max": [
        -883.3576049804688,
        -3592.844970703125,
        1435.765869140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9528772234916687,
        -0.2737281024456024,
        0.130758598446846
      ],
      "plane_d": -2123.362548828125,
      "bbox_min": [
        -1184.6175537109375,
        -3494.98193359375,
        621.68359375
      ],
      "bbox_max": [
        -1131.9222412109375,
        -3290.127197265625,
        794.9396362304688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9856189489364624,
        -0.10732632130384445,
        0.13052378594875336
      ],
      "plane_d": -1595.8048095703125,
      "bbox_min": [
        -1182.1806640625,
        -3399.0576171875,
        621.68359375
      ],
      "bbox_max": [
        -1144.192626953125,
        -3293.62548828125,
        794.9396362304688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8007402420043945,
        -0.5945212841033936,
        0.073208749294281
      ],
      "plane_d": -2958.124267578125,
      "bbox_min": [
        -1182.1806640625,
        -3319.947509765625,
        715.8609619140625
      ],
      "bbox_max": [
        -1160.2471923828125,
        -3293.62548828125,
        784.7702026367188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8007402420043945,
        -0.5945212841033936,
        0.073208749294281
      ],
      "plane_d": -2958.124267578125,
      "bbox_min": [
        -1184.6175537109375,
        -3294.763427734375,
        729.0673217773438
      ],
      "bbox_max": [
        -1180.3018798828125,
        -3290.127197265625,
        740.3759155273438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6382936835289001,
        0.7293487191200256,
        0.2462347000837326
      ],
      "plane_d": 1514.509521484375,
      "bbox_min": [
        -1206.0413818359375,
        -3670.5068359375,
        730.822509765625
      ],
      "bbox_max": [
        -848.9866943359375,
        -3231.95166015625,
        1517.0201416015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6734017729759216,
        -0.7359853386878967,
        0.06968268007040024
      ],
      "plane_d": -3378.893798828125,
      "bbox_min": [
        -1138.5511474609375,
        -3670.5068359375,
        860.0905151367188
      ],
      "bbox_max": [
        -848.9866943359375,
        -3363.30712890625,
        1517.0201416015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9931049346923828,
        0.0022958379704505205,
        0.11720679700374603
      ],
      "plane_d": -1221.6827392578125,
      "bbox_min": [
        -1138.5511474609375,
        -3670.5068359375,
        860.0905151367188
      ],
      "bbox_max": [
        -848.9866943359375,
        -3363.30712890625,
        1517.0201416015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9792153239250183,
        -0.19332727789878845,
        0.061334479600191116
      ],
      "plane_d": -1825.3980712890625,
      "bbox_min": [
        -1124.3956298828125,
        -3670.5068359375,
        963.5977172851562
      ],
      "bbox_max": [
        -848.9866943359375,
        -3441.16357421875,
        1517.0201416015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6437557935714722,
        -0.7623260021209717,
        0.06661495566368103
      ],
      "plane_d": -3444.360595703125,
      "bbox_min": [
        -883.3576049804688,
        -3670.5068359375,
        1435.7657470703125
      ],
      "bbox_max": [
        -848.9866943359375,
        -3646.800048828125,
        1517.0201416015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9945406317710876,
        -0.05085870251059532,
        0.09111718833446503
      ],
      "plane_d": -1379.3016357421875,
      "bbox_min": [
        -1138.5511474609375,
        -3461.161865234375,
        860.0905151367188
      ],
      "bbox_max": [
        -1111.7132568359375,
        -3363.30712890625,
        1071.447998046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9533829092979431,
        -0.23182019591331482,
        0.1931847333908081
      ],
      "plane_d": -2031.31396484375,
      "bbox_min": [
        -1138.5511474609375,
        -3368.7138671875,
        860.0905151367188
      ],
      "bbox_max": [
        -1134.300048828125,
        -3363.30712890625,
        878.1983032226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6707790493965149,
        -0.7331188917160034,
        0.11221480369567871
      ],
      "plane_d": -3421.490234375,
      "bbox_min": [
        -1114.5927734375,
        -3592.844970703125,
        1012.494140625
      ],
      "bbox_max": [
        -956.1067504882812,
        -3472.395751953125,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9792153239250183,
        -0.19332727789878845,
        0.061334479600191116
      ],
      "plane_d": -1825.3980712890625,
      "bbox_min": [
        -1114.5927734375,
        -3486.007568359375,
        1012.494140625
      ],
      "bbox_max": [
        -1107.164794921875,
        -3472.395751953125,
        1103.378662109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9931049346923828,
        0.0022958379704505205,
        0.11720679700374603
      ],
      "plane_d": -1221.6827392578125,
      "bbox_min": [
        -1111.1741943359375,
        -3477.0634765625,
        1076.2362060546875
      ],
      "bbox_max": [
        -1109.1981201171875,
        -3472.395751953125,
        1093.070556640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8007402420043945,
        -0.5945212841033936,
        0.073208749294281
      ],
      "plane_d": -2958.124267578125,
      "bbox_min": [
        -1206.0413818359375,
        -3365.699951171875,
        730.822509765625
      ],
      "bbox_max": [
        -1126.0,
        -3259.3720703125,
        888.5076904296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3322.0,
      "bbox_min": [
        -1154.881103515625,
        -3339.750732421875,
        856.0769653320312
      ],
      "bbox_max": [
        -1126.0,
        -3314.0,
        888.5076904296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9138116240501404,
        -0.0,
        -0.40613850951194763
      ],
      "plane_d": -697.9490356445312,
      "bbox_min": [
        -1147.9173583984375,
        -3322.0,
        860.0
      ],
      "bbox_max": [
        -1146.0,
        -3314.0,
        864.31396484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9138116240501404,
        -0.0,
        -0.40613850951194763
      ],
      "plane_d": -697.9490356445312,
      "bbox_min": [
        -1149.4439697265625,
        -3322.0,
        861.1472778320312
      ],
      "bbox_max": [
        -1134.612548828125,
        -3316.840576171875,
        880.6557006835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7746099233627319,
        -0.5822634696960449,
        0.2468777596950531
      ],
      "plane_d": -3030.36767578125,
      "bbox_min": [
        -1136.6383056640625,
        -3322.0,
        877.655517578125
      ],
      "bbox_max": [
        -1134.612548828125,
        -3320.2197265625,
        880.6557006835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8208402991294861,
        1.7694263831913304e-08,
        0.5711577534675598
      ],
      "plane_d": -1432.6689453125,
      "bbox_min": [
        -1149.4361572265625,
        -3339.750732421875,
        856.7926025390625
      ],
      "bbox_max": [
        -1134.300048828125,
        -3322.0,
        879.8124389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7746099233627319,
        -0.5822634696960449,
        0.2468777596950531
      ],
      "plane_d": -3030.36767578125,
      "bbox_min": [
        -1135.193115234375,
        -3323.10009765625,
        877.9910278320312
      ],
      "bbox_max": [
        -1134.300048828125,
        -3322.0,
        879.8124389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9845805764198303,
        -0.14805786311626434,
        0.09316641837358475
      ],
      "plane_d": -1703.1788330078125,
      "bbox_min": [
        -1154.92236328125,
        -3365.699951171875,
        796.5574951171875
      ],
      "bbox_max": [
        -1134.300048828125,
        -3320.640380859375,
        878.1983032226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9533829092979431,
        -0.23182019591331482,
        0.1931847333908081
      ],
      "plane_d": -2031.31396484375,
      "bbox_min": [
        -1149.1702880859375,
        -3365.699951171875,
        834.3935546875
      ],
      "bbox_max": [
        -1134.300048828125,
        -3322.353759765625,
        878.1983032226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8208402991294861,
        1.7694263831913304e-08,
        0.5711577534675598
      ],
      "plane_d": -1432.6689453125,
      "bbox_min": [
        -1149.1702880859375,
        -3365.699951171875,
        856.8275146484375
      ],
      "bbox_max": [
        -1134.300048828125,
        -3322.353759765625,
        878.1983032226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3322.0,
      "bbox_min": [
        -1149.990234375,
        -3322.0,
        865.8651733398438
      ],
      "bbox_max": [
        -1148.18798828125,
        -3320.640380859375,
        870.4451904296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9138116240501404,
        -0.0,
        -0.40613850951194763
      ],
      "plane_d": -697.9490356445312,
      "bbox_min": [
        -1149.990234375,
        -3322.0,
        865.8651733398438
      ],
      "bbox_max": [
        -1148.606689453125,
        -3320.640380859375,
        868.9780883789062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7552521228790283,
        -0.561424732208252,
        0.3382256329059601
      ],
      "plane_d": -2654.937744140625,
      "bbox_min": [
        -1478.322509765625,
        -3657.87451171875,
        746.2530517578125
      ],
      "bbox_max": [
        -345.5777587890625,
        -2690.8427734375,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8214666247367859,
        -0.2627931237220764,
        0.5060952305793762
      ],
      "plane_d": -1936.05078125,
      "bbox_min": [
        -840.498779296875,
        -3331.0029296875,
        942.820068359375
      ],
      "bbox_max": [
        -345.5777587890625,
        -2690.8427734375,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6356639862060547,
        -0.35781198740005493,
        0.6840335130691528
      ],
      "plane_d": -2381.548583984375,
      "bbox_min": [
        -695.2380981445312,
        -3253.36376953125,
        1302.5999755859375
      ],
      "bbox_max": [
        -511.1015625,
        -2699.56005859375,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4018848240375519,
        -0.6489609479904175,
        0.6460171937942505
      ],
      "plane_d": -3022.886474609375,
      "bbox_min": [
        -695.2380981445312,
        -2930.939453125,
        1302.5999755859375
      ],
      "bbox_max": [
        -511.1015625,
        -2699.56005859375,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9639432430267334,
        0.2661080062389374
      ],
      "plane_d": -3171.8916015625,
      "bbox_min": [
        -840.498779296875,
        -3030.260986328125,
        942.820068359375
      ],
      "bbox_max": [
        -695.023193359375,
        -2690.8427734375,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4018848240375519,
        -0.6489609479904175,
        0.6460171937942505
      ],
      "plane_d": -3022.886474609375,
      "bbox_min": [
        -709.314697265625,
        -2930.939453125,
        1302.5999755859375
      ],
      "bbox_max": [
        -695.023193359375,
        -2690.8427734375,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7746099233627319,
        -0.5822634696960449,
        0.2468777596950531
      ],
      "plane_d": -3030.36767578125,
      "bbox_min": [
        -1478.322509765625,
        -3657.87451171875,
        746.2530517578125
      ],
      "bbox_max": [
        -513.5322265625,
        -2930.939453125,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.14039453864097595,
        -0.9834563732147217,
        0.11446819454431534
      ],
      "plane_d": -2961.9658203125,
      "bbox_min": [
        -1327.09716796875,
        -3461.04345703125,
        746.2530517578125
      ],
      "bbox_max": [
        -513.5322265625,
        -2930.939453125,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.060430631041526794,
        -0.9956679344177246,
        0.07066542655229568
      ],
      "plane_d": -3147.843994140625,
      "bbox_min": [
        -1327.09716796875,
        -3103.500244140625,
        824.4575805664062
      ],
      "bbox_max": [
        -753.2095336914062,
        -2930.939453125,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.35227170586586,
        -0.9041997790336609,
        0.2415105253458023
      ],
      "plane_d": -2671.578125,
      "bbox_min": [
        -1026.85400390625,
        -3015.74853515625,
        995.389404296875
      ],
      "bbox_max": [
        -753.2095336914062,
        -2930.939453125,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9639432430267334,
        0.2661080062389374
      ],
      "plane_d": -3171.8916015625,
      "bbox_min": [
        -839.289306640625,
        -3015.74853515625,
        995.389404296875
      ],
      "bbox_max": [
        -753.2095336914062,
        -2930.939453125,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8007402420043945,
        -0.5945212841033936,
        0.073208749294281
      ],
      "plane_d": -2958.124267578125,
      "bbox_min": [
        -1327.09716796875,
        -3103.500244140625,
        824.4575805664062
      ],
      "bbox_max": [
        -1314.5831298828125,
        -3085.589599609375,
        833.44384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.12456259876489639,
        -0.9855428338050842,
        0.11484554409980774
      ],
      "plane_d": -2984.98828125,
      "bbox_min": [
        -1314.62060546875,
        -3461.04345703125,
        746.2530517578125
      ],
      "bbox_max": [
        -513.5322265625,
        -3006.767333984375,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.060430631041526794,
        -0.9956679344177246,
        0.07066542655229568
      ],
      "plane_d": -3147.843994140625,
      "bbox_min": [
        -1026.85400390625,
        -3044.44287109375,
        860.7633666992188
      ],
      "bbox_max": [
        -824.54638671875,
        -3006.767333984375,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.35227170586586,
        -0.9041997790336609,
        0.2415105253458023
      ],
      "plane_d": -2671.578125,
      "bbox_min": [
        -1026.85400390625,
        -3021.233642578125,
        975.5206909179688
      ],
      "bbox_max": [
        -824.54638671875,
        -3006.767333984375,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9639432430267334,
        0.2661080062389374
      ],
      "plane_d": -3171.8916015625,
      "bbox_min": [
        -839.7464599609375,
        -3021.233642578125,
        975.5206909179688
      ],
      "bbox_max": [
        -824.54638671875,
        -3012.109619140625,
        1008.571044921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.060430631041526794,
        -0.9956679344177246,
        0.07066542655229568
      ],
      "plane_d": -3147.843994140625,
      "bbox_min": [
        -1314.62060546875,
        -3461.04345703125,
        746.2530517578125
      ],
      "bbox_max": [
        -513.5322265625,
        -3006.767333984375,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.35227170586586,
        -0.9041997790336609,
        0.2415105253458023
      ],
      "plane_d": -2671.578125,
      "bbox_min": [
        -1026.85400390625,
        -3030.260986328125,
        942.820068359375
      ],
      "bbox_max": [
        -830.856201171875,
        -3006.767333984375,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9639432430267334,
        0.2661080062389374
      ],
      "plane_d": -3171.8916015625,
      "bbox_min": [
        -840.498779296875,
        -3030.260986328125,
        942.820068359375
      ],
      "bbox_max": [
        -830.856201171875,
        -3019.2890625,
        982.5640258789062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4902830421924591,
        0.7414035797119141,
        0.4581957757472992
      ],
      "plane_d": 1563.4337158203125,
      "bbox_min": [
        -1314.62060546875,
        -3461.04345703125,
        746.2530517578125
      ],
      "bbox_max": [
        -513.5322265625,
        -3102.529052734375,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8007402420043945,
        -0.5945212841033936,
        0.073208749294281
      ],
      "plane_d": -2958.124267578125,
      "bbox_min": [
        -1314.62060546875,
        -3356.1904296875,
        746.2530517578125
      ],
      "bbox_max": [
        -1005.9225463867188,
        -3102.529052734375,
        1087.07763671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6382936835289001,
        0.7293487191200256,
        0.2462347000837326
      ],
      "plane_d": 1514.509521484375,
      "bbox_min": [
        -1133.8880615234375,
        -3356.1904296875,
        882.0863037109375
      ],
      "bbox_max": [
        -1005.9225463867188,
        -3266.954345703125,
        1087.07763671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3322.0,
      "bbox_min": [
        -1133.8880615234375,
        -3322.0,
        882.0863037109375
      ],
      "bbox_max": [
        -1126.0,
        -3322.0,
        906.8359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.43772801756858826,
        -0.8991074562072754,
        0.0
      ],
      "plane_d": -2195.2607421875,
      "bbox_min": [
        -1478.322509765625,
        -3657.87451171875,
        824.7872314453125
      ],
      "bbox_max": [
        -861.835205078125,
        -3033.836669921875,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4557587504386902,
        -0.8900548815727234,
        -0.00928233191370964
      ],
      "plane_d": -2133.771484375,
      "bbox_min": [
        -1478.322509765625,
        -3159.5546875,
        832.278564453125
      ],
      "bbox_max": [
        -1216.4732666015625,
        -3033.836669921875,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3377978503704071,
        -0.8362663984298706,
        0.4319157302379608
      ],
      "plane_d": -2702.277587890625,
      "bbox_min": [
        -1478.322509765625,
        -3159.5546875,
        1292.3797607421875
      ],
      "bbox_max": [
        -1411.0396728515625,
        -3128.560791015625,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7215278148651123,
        -0.4943443834781647,
        0.48478996753692627
      ],
      "plane_d": -2886.926513671875,
      "bbox_min": [
        -1327.09716796875,
        -3087.136962890625,
        833.381103515625
      ],
      "bbox_max": [
        -1325.873046875,
        -3085.589599609375,
        833.7279663085938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8007402420043945,
        -0.5945212841033936,
        0.073208749294281
      ],
      "plane_d": -2958.124267578125,
      "bbox_min": [
        -1327.09716796875,
        -3087.136962890625,
        833.381103515625
      ],
      "bbox_max": [
        -1325.9395751953125,
        -3085.589599609375,
        833.595947265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3377978503704071,
        -0.8362663984298706,
        0.4319157302379608
      ],
      "plane_d": -2702.277587890625,
      "bbox_min": [
        -1474.7017822265625,
        -3657.87451171875,
        824.7872314453125
      ],
      "bbox_max": [
        -861.835205078125,
        -3087.09765625,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8007402420043945,
        -0.5945212841033936,
        0.073208749294281
      ],
      "plane_d": -2958.124267578125,
      "bbox_min": [
        -1325.9541015625,
        -3282.366455078125,
        825.4610595703125
      ],
      "bbox_max": [
        -1181.72705078125,
        -3087.09765625,
        866.6787719726562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7215278148651123,
        -0.4943443834781647,
        0.48478996753692627
      ],
      "plane_d": -2886.926513671875,
      "bbox_min": [
        -1325.9395751953125,
        -3271.1650390625,
        833.595947265625
      ],
      "bbox_max": [
        -1183.9248046875,
        -3087.09765625,
        866.6787719726562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6734017729759216,
        -0.7359853386878967,
        0.06968268007040024
      ],
      "plane_d": -3378.893798828125,
      "bbox_min": [
        -1187.63818359375,
        -3657.87451171875,
        824.7872314453125
      ],
      "bbox_max": [
        -861.835205078125,
        -3261.96630859375,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6382936835289001,
        0.7293487191200256,
        0.2462347000837326
      ],
      "plane_d": 1514.509521484375,
      "bbox_min": [
        -1187.63818359375,
        -3657.87451171875,
        824.7872314453125
      ],
      "bbox_max": [
        -861.835205078125,
        -3261.96630859375,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9945406317710876,
        -0.05085870251059532,
        0.09111718833446503
      ],
      "plane_d": -1379.3016357421875,
      "bbox_min": [
        -1124.5316162109375,
        -3657.87451171875,
        971.9288330078125
      ],
      "bbox_max": [
        -861.835205078125,
        -3388.79541015625,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6437557935714722,
        -0.7623260021209717,
        0.06661495566368103
      ],
      "plane_d": -3444.360595703125,
      "bbox_min": [
        -877.6963500976562,
        -3657.87451171875,
        1490.475341796875
      ],
      "bbox_max": [
        -861.835205078125,
        -3646.800048828125,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9931049346923828,
        0.0022958379704505205,
        0.11720679700374603
      ],
      "plane_d": -1221.6827392578125,
      "bbox_min": [
        -1111.7132568359375,
        -3472.640380859375,
        1071.447998046875
      ],
      "bbox_max": [
        -1108.9974365234375,
        -3461.161865234375,
        1094.684326171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7215278148651123,
        -0.4943443834781647,
        0.48478996753692627
      ],
      "plane_d": -2886.926513671875,
      "bbox_min": [
        -1187.63818359375,
        -3322.0,
        824.7872314453125
      ],
      "bbox_max": [
        -1126.0,
        -3261.96630859375,
        912.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8007402420043945,
        -0.5945212841033936,
        0.073208749294281
      ],
      "plane_d": -2958.124267578125,
      "bbox_min": [
        -1187.63818359375,
        -3316.840576171875,
        824.7872314453125
      ],
      "bbox_max": [
        -1146.776123046875,
        -3271.1650390625,
        866.0571899414062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9138116240501404,
        -0.0,
        -0.40613850951194763
      ],
      "plane_d": -697.9490356445312,
      "bbox_min": [
        -1148.692138671875,
        -3316.840576171875,
        861.7461547851562
      ],
      "bbox_max": [
        -1146.776123046875,
        -3314.0,
        866.0571899414062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.950871467590332,
        0.0,
        0.3095860481262207
      ],
      "plane_d": -1362.532470703125,
      "bbox_min": [
        -1150.0,
        -3322.0,
        864.3139038085938
      ],
      "bbox_max": [
        -1126.0,
        -3314.0,
        912.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3322.0,
      "bbox_min": [
        -1150.0,
        -3322.0,
        864.3139038085938
      ],
      "bbox_max": [
        -1126.0,
        -3314.0,
        912.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9138116240501404,
        -0.0,
        -0.40613850951194763
      ],
      "plane_d": -697.9490356445312,
      "bbox_min": [
        -1150.0,
        -3322.0,
        864.3139038085938
      ],
      "bbox_max": [
        -1147.9173583984375,
        -3314.0,
        869.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6707790493965149,
        -0.7331188917160034,
        0.11221480369567871
      ],
      "plane_d": -3421.490234375,
      "bbox_min": [
        -1109.9140625,
        -3565.672607421875,
        1086.9161376953125
      ],
      "bbox_max": [
        -985.8045043945312,
        -3470.2734375,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9945406317710876,
        -0.05085870251059532,
        0.09111718833446503
      ],
      "plane_d": -1379.3016357421875,
      "bbox_min": [
        -1109.9140625,
        -3484.092529296875,
        1086.9161376953125
      ],
      "bbox_max": [
        -1090.06982421875,
        -3470.2734375,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9792153239250183,
        -0.19332727789878845,
        0.061334479600191116
      ],
      "plane_d": -1825.3980712890625,
      "bbox_min": [
        -1108.4205322265625,
        -3484.092529296875,
        1097.012451171875
      ],
      "bbox_max": [
        -1106.3704833984375,
        -3479.75146484375,
        1117.1605224609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9931049346923828,
        0.0022958379704505205,
        0.11720679700374603
      ],
      "plane_d": -1221.6827392578125,
      "bbox_min": [
        -1109.9140625,
        -3483.7431640625,
        1086.9161376953125
      ],
      "bbox_max": [
        -1106.3704833984375,
        -3472.537353515625,
        1117.1605224609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9792153239250183,
        -0.19332727789878845,
        0.061334479600191116
      ],
      "plane_d": -1825.3980712890625,
      "bbox_min": [
        -1109.1981201171875,
        -3483.7431640625,
        1093.070556640625
      ],
      "bbox_max": [
        -1106.3704833984375,
        -3477.0634765625,
        1117.1605224609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6268800497055054,
        -0.7762154936790466,
        0.06716372817754745
      ],
      "plane_d": -3472.729736328125,
      "bbox_min": [
        -3260.67529296875,
        -3646.800048828125,
        660.0
      ],
      "bbox_max": [
        -953.4501953125,
        -3037.23291015625,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9792153239250183,
        -0.19332727789878845,
        0.061334479600191116
      ],
      "plane_d": -1825.3980712890625,
      "bbox_min": [
        -1487.869140625,
        -3503.1201171875,
        660.3853149414062
      ],
      "bbox_max": [
        -1106.3704833984375,
        -3155.73876953125,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9528772234916687,
        -0.2737281024456024,
        0.130758598446846
      ],
      "plane_d": -2123.362548828125,
      "bbox_min": [
        -1133.9759521484375,
        -3503.1201171875,
        660.3853149414062
      ],
      "bbox_max": [
        -1130.929443359375,
        -3494.23974609375,
        673.797607421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2307186871767044,
        0.9716865420341492,
        0.05093211308121681
      ],
      "plane_d": 3619.826416015625,
      "bbox_min": [
        -3260.67529296875,
        -3618.21142578125,
        860.0
      ],
      "bbox_max": [
        -1276.5831298828125,
        -3037.23291015625,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.446391761302948,
        0.8844631910324097,
        0.13586436212062836
      ],
      "plane_d": 3523.942626953125,
      "bbox_min": [
        -3260.67529296875,
        -3618.21142578125,
        892.0
      ],
      "bbox_max": [
        -1276.5831298828125,
        -3270.034423828125,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4469253122806549,
        0.8841609358787537,
        0.13607771694660187
      ],
      "plane_d": 3523.403076171875,
      "bbox_min": [
        -3260.67529296875,
        -3618.21142578125,
        892.0
      ],
      "bbox_max": [
        -1276.5831298828125,
        -3270.034423828125,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.32936930656433105,
        -0.8532378077507019,
        0.40435269474983215
      ],
      "plane_d": -2643.852783203125,
      "bbox_min": [
        -3260.67529296875,
        -3618.21142578125,
        892.0
      ],
      "bbox_max": [
        -1455.339599609375,
        -3270.034423828125,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8624072670936584,
        -0.13326707482337952,
        0.48835813999176025
      ],
      "plane_d": 1580.2606201171875,
      "bbox_min": [
        -3260.67529296875,
        -3618.21142578125,
        969.5125122070312
      ],
      "bbox_max": [
        -1851.0653076171875,
        -3270.034423828125,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7868428826332092,
        0.027674341574311256,
        0.616532564163208
      ],
      "plane_d": 1719.455078125,
      "bbox_min": [
        -3260.67529296875,
        -3618.21142578125,
        969.5125122070312
      ],
      "bbox_max": [
        -1851.0653076171875,
        -3270.034423828125,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2802785038948059,
        -0.8504679203033447,
        0.4451383650302887
      ],
      "plane_d": -2792.41162109375,
      "bbox_min": [
        -2349.54345703125,
        -3506.75830078125,
        969.5125122070312
      ],
      "bbox_max": [
        -1851.0653076171875,
        -3270.034423828125,
        1419.850830078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2753306031227112,
        -0.8354538679122925,
        0.4756152629852295
      ],
      "plane_d": -2793.050048828125,
      "bbox_min": [
        -2319.057373046875,
        -3418.607421875,
        969.5125122070312
      ],
      "bbox_max": [
        -1851.0653076171875,
        -3270.034423828125,
        1419.850830078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3485427498817444,
        -0.8757609128952026,
        0.3340070843696594
      ],
      "plane_d": -2608.564453125,
      "bbox_min": [
        -2089.408203125,
        -3418.607421875,
        969.5125122070312
      ],
      "bbox_max": [
        -1851.0653076171875,
        -3336.720703125,
        1050.3902587890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.20575138926506042,
        0.1004783883690834,
        0.9734323620796204
      ],
      "plane_d": -226.04217529296875,
      "bbox_min": [
        -2089.408203125,
        -3418.607421875,
        969.5125122070312
      ],
      "bbox_max": [
        -1851.0653076171875,
        -3336.720703125,
        1050.3902587890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.21186989545822144,
        0.07687602192163467,
        0.9742696285247803
      ],
      "plane_d": -294.561767578125,
      "bbox_min": [
        -1920.9259033203125,
        -3372.69189453125,
        969.5125122070312
      ],
      "bbox_max": [
        -1851.0653076171875,
        -3353.709716796875,
        986.3633422851562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.21823850274085999,
        0.07879546284675598,
        0.9727092981338501
      ],
      "plane_d": -274.47198486328125,
      "bbox_min": [
        -1920.9259033203125,
        -3372.69189453125,
        980.9876098632812
      ],
      "bbox_max": [
        -1899.3868408203125,
        -3361.1201171875,
        986.3633422851562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.24250808358192444,
        -0.909406840801239,
        0.3378889858722687
      ],
      "plane_d": -2927.0478515625,
      "bbox_min": [
        -1906.34521484375,
        -3361.1201171875,
        969.6503295898438
      ],
      "bbox_max": [
        -1851.142333984375,
        -3336.720703125,
        1050.3902587890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.21603241562843323,
        -0.9093504548072815,
        0.35554423928260803
      ],
      "plane_d": -2994.511962890625,
      "bbox_min": [
        -1901.143798828125,
        -3361.1201171875,
        969.6503295898438
      ],
      "bbox_max": [
        -1851.142333984375,
        -3341.549560546875,
        1016.5908813476562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.22970595955848694,
        -0.8470718264579773,
        0.4792749881744385
      ],
      "plane_d": -2933.39697265625,
      "bbox_min": [
        -2132.0,
        -3303.68017578125,
        1302.5999755859375
      ],
      "bbox_max": [
        -2118.65673828125,
        -3288.776123046875,
        1329.7178955078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.22970595955848694,
        -0.8470718264579773,
        0.4792749881744385
      ],
      "plane_d": -2933.39697265625,
      "bbox_min": [
        -2130.3798828125,
        -3303.68017578125,
        1302.5999755859375
      ],
      "bbox_max": [
        -2117.939453125,
        -3291.368896484375,
        1318.740234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.23947833478450775,
        -0.8831087350845337,
        0.4034464955329895
      ],
      "plane_d": -2932.8583984375,
      "bbox_min": [
        -2130.3798828125,
        -3459.55078125,
        892.0
      ],
      "bbox_max": [
        -1455.339599609375,
        -3291.50830078125,
        1318.150146484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3485427498817444,
        -0.8757609128952026,
        0.3340070843696594
      ],
      "plane_d": -2608.564453125,
      "bbox_min": [
        -2130.3798828125,
        -3418.607421875,
        946.0342407226562
      ],
      "bbox_max": [
        -1742.0198974609375,
        -3291.50830078125,
        1318.150146484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.22970595955848694,
        -0.8470718264579773,
        0.4792749881744385
      ],
      "plane_d": -2933.39697265625,
      "bbox_min": [
        -2130.3798828125,
        -3303.68017578125,
        1302.5999755859375
      ],
      "bbox_max": [
        -2099.03857421875,
        -3291.50830078125,
        1318.150146484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.20575138926506042,
        0.1004783883690834,
        0.9734323620796204
      ],
      "plane_d": -226.04217529296875,
      "bbox_min": [
        -2089.408203125,
        -3418.607421875,
        946.0342407226562
      ],
      "bbox_max": [
        -1742.0198974609375,
        -3328.522216796875,
        1073.7103271484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.21186989545822144,
        0.07687602192163467,
        0.9742696285247803
      ],
      "plane_d": -294.561767578125,
      "bbox_min": [
        -1963.5389404296875,
        -3397.61865234375,
        946.0342407226562
      ],
      "bbox_max": [
        -1742.0198974609375,
        -3346.88037109375,
        997.9432983398438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2235765904188156,
        0.04341130331158638,
        0.9737191796302795
      ],
      "plane_d": -385.780029296875,
      "bbox_min": [
        -1797.066650390625,
        -3370.23291015625,
        946.0342407226562
      ],
      "bbox_max": [
        -1742.0198974609375,
        -3357.16748046875,
        959.073486328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.21823850274085999,
        0.07879546284675598,
        0.9727092981338501
      ],
      "plane_d": -274.47198486328125,
      "bbox_min": [
        -1963.5389404296875,
        -3397.61865234375,
        959.013916015625
      ],
      "bbox_max": [
        -1805.2481689453125,
        -3346.88037109375,
        997.9432983398438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.21603241562843323,
        -0.9093504548072815,
        0.35554423928260803
      ],
      "plane_d": -2994.511962890625,
      "bbox_min": [
        -1851.142333984375,
        -3353.709716796875,
        959.013916015625
      ],
      "bbox_max": [
        -1805.2481689453125,
        -3346.88037109375,
        969.6503295898438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.21603241562843323,
        -0.9093504548072815,
        0.35554423928260803
      ],
      "plane_d": -2994.511962890625,
      "bbox_min": [
        -1908.0928955078125,
        -3353.674072265625,
        959.3063354492188
      ],
      "bbox_max": [
        -1805.5211181640625,
        -3328.522216796875,
        1073.7103271484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.24250808358192444,
        -0.909406840801239,
        0.3378889858722687
      ],
      "plane_d": -2927.0478515625,
      "bbox_min": [
        -1908.0928955078125,
        -3341.549560546875,
        1016.5908813476562
      ],
      "bbox_max": [
        -1869.69921875,
        -3328.522216796875,
        1073.7103271484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2235765904188156,
        0.04341130331158638,
        0.9737191796302795
      ],
      "plane_d": -385.780029296875,
      "bbox_min": [
        -2105.126953125,
        -3459.55078125,
        892.0
      ],
      "bbox_max": [
        -1455.339599609375,
        -3372.009033203125,
        1086.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1624.5,
      "bbox_min": [
        -1624.5,
        -3441.5,
        892.0
      ],
      "bbox_max": [
        -1610.0,
        -3426.5,
        922.6275634765625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1610.0,
      "bbox_min": [
        -1624.5,
        -3441.5,
        892.0
      ],
      "bbox_max": [
        -1610.0,
        -3426.5,
        922.6275634765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3441.5,
      "bbox_min": [
        -1624.5,
        -3441.5,
        892.0
      ],
      "bbox_max": [
        -1610.0,
        -3426.5,
        922.6275634765625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -892.0,
      "bbox_min": [
        -1624.5,
        -3441.5,
        892.0
      ],
      "bbox_max": [
        -1610.0,
        -3426.5,
        892.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -892.0,
      "bbox_min": [
        -2097.268310546875,
        -3426.5,
        892.0
      ],
      "bbox_max": [
        -1494.023193359375,
        -3378.96923828125,
        1028.596923828125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.21823850274085999,
        0.07879546284675598,
        0.9727092981338501
      ],
      "plane_d": -274.47198486328125,
      "bbox_min": [
        -2097.268310546875,
        -3426.5,
        892.0
      ],
      "bbox_max": [
        -1518.5125732421875,
        -3378.96923828125,
        1028.596923828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3411.5,
      "bbox_min": [
        -2097.268310546875,
        -3426.5,
        892.0
      ],
      "bbox_max": [
        -1518.5125732421875,
        -3411.5,
        1028.596923828125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8618017435073853,
        0.5072331428527832,
        0.003500441089272499
      ],
      "plane_d": 3538.946533203125,
      "bbox_min": [
        -2097.268310546875,
        -3421.255859375,
        1027.470703125
      ],
      "bbox_max": [
        -2096.970458984375,
        -3420.75,
        1028.596923828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 915.0,
      "bbox_min": [
        -1624.5,
        -3426.5,
        915.0
      ],
      "bbox_max": [
        -1594.19287109375,
        -3411.5,
        915.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.21186989545822144,
        0.07687602192163467,
        0.9742696285247803
      ],
      "plane_d": -294.561767578125,
      "bbox_min": [
        -1893.4989013671875,
        -3402.5927734375,
        965.1317138671875
      ],
      "bbox_max": [
        -1821.7552490234375,
        -3378.96923828125,
        981.5137939453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8618017435073853,
        0.5072331428527832,
        0.003500441089272499
      ],
      "plane_d": 3538.946533203125,
      "bbox_min": [
        -2097.664794921875,
        -3421.361083984375,
        1028.586181640625
      ],
      "bbox_max": [
        -2096.9150390625,
        -3420.08837890625,
        1030.3167724609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.21823850274085999,
        0.07879546284675598,
        0.9727092981338501
      ],
      "plane_d": -274.47198486328125,
      "bbox_min": [
        -2105.126953125,
        -3459.55078125,
        892.0
      ],
      "bbox_max": [
        -1455.339599609375,
        -3402.5927734375,
        1086.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.20575138926506042,
        0.1004783883690834,
        0.9734323620796204
      ],
      "plane_d": -226.04217529296875,
      "bbox_min": [
        -2077.546630859375,
        -3459.55078125,
        919.2982177734375
      ],
      "bbox_max": [
        -1610.0,
        -3426.5,
        1026.71435546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3441.5,
      "bbox_min": [
        -1624.5,
        -3441.5,
        919.2982177734375
      ],
      "bbox_max": [
        -1610.0,
        -3441.5,
        925.4306640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3411.5,
      "bbox_min": [
        -2024.8485107421875,
        -3426.5,
        892.0
      ],
      "bbox_max": [
        -1480.912109375,
        -3411.5,
        1013.88330078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.20575138926506042,
        0.1004783883690834,
        0.9734323620796204
      ],
      "plane_d": -226.04217529296875,
      "bbox_min": [
        -2024.8485107421875,
        -3426.5,
        892.0
      ],
      "bbox_max": [
        -1480.912109375,
        -3411.5,
        1013.88330078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -892.0,
      "bbox_min": [
        -1495.892822265625,
        -3426.5,
        892.0
      ],
      "bbox_max": [
        -1480.912109375,
        -3416.870849609375,
        892.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3426.5,
      "bbox_min": [
        -2105.126953125,
        -3441.5,
        892.0
      ],
      "bbox_max": [
        -1455.339599609375,
        -3407.63330078125,
        1086.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3441.5,
      "bbox_min": [
        -1624.5,
        -3441.5,
        922.1774291992188
      ],
      "bbox_max": [
        -1610.0,
        -3426.5,
        1000.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1624.5,
      "bbox_min": [
        -1624.5,
        -3441.5,
        924.215576171875
      ],
      "bbox_max": [
        -1624.5,
        -3426.5,
        1000.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 915.0,
      "bbox_min": [
        -2105.126953125,
        -3426.5,
        892.0
      ],
      "bbox_max": [
        -1455.339599609375,
        -3407.63330078125,
        1086.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8618017435073853,
        0.5072331428527832,
        0.003500441089272499
      ],
      "plane_d": 3538.946533203125,
      "bbox_min": [
        -2105.126953125,
        -3425.0,
        1030.201416015625
      ],
      "bbox_max": [
        -2095.0,
        -3407.63330078125,
        1086.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3411.5,
      "bbox_min": [
        -1588.841064453125,
        -3426.5,
        892.0
      ],
      "bbox_max": [
        -1455.339599609375,
        -3411.5,
        915.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -892.0,
      "bbox_min": [
        -1483.3101806640625,
        -3426.5,
        892.0
      ],
      "bbox_max": [
        -1455.339599609375,
        -3419.858642578125,
        892.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.01903552934527397,
        0.9815307855606079,
        -0.19035546481609344
      ],
      "plane_d": 3524.079833984375,
      "bbox_min": [
        -2110.497314453125,
        -3419.54296875,
        935.5919799804688
      ],
      "bbox_max": [
        -1515.6566162109375,
        -3361.262451171875,
        1178.8031005859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.056889183819293976,
        0.9831775426864624,
        -0.17356735467910767
      ],
      "plane_d": 3449.109619140625,
      "bbox_min": [
        -1664.755859375,
        -3419.54296875,
        1047.4222412109375
      ],
      "bbox_max": [
        -1621.5601806640625,
        -3395.459716796875,
        1178.8031005859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2235765904188156,
        0.04341130331158638,
        0.9737191796302795
      ],
      "plane_d": -385.780029296875,
      "bbox_min": [
        -2110.497314453125,
        -3417.519287109375,
        935.5919799804688
      ],
      "bbox_max": [
        -1694.455322265625,
        -3361.262451171875,
        1086.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.21186989545822144,
        0.07687602192163467,
        0.9742696285247803
      ],
      "plane_d": -294.561767578125,
      "bbox_min": [
        -1861.920166015625,
        -3380.98876953125,
        959.073486328125
      ],
      "bbox_max": [
        -1797.066650390625,
        -3370.23291015625,
        974.025634765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8618017435073853,
        0.5072331428527832,
        0.003500441089272499
      ],
      "plane_d": 3538.946533203125,
      "bbox_min": [
        -2110.497314453125,
        -3417.519287109375,
        1062.69677734375
      ],
      "bbox_max": [
        -2099.403076171875,
        -3398.669677734375,
        1086.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.11021039634943008,
        -0.9280050992965698,
        0.3558935821056366
      ],
      "plane_d": -3234.49072265625,
      "bbox_min": [
        -2230.8291015625,
        -3458.6162109375,
        860.0
      ],
      "bbox_max": [
        -1332.0,
        -3037.23291015625,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1012493446469307,
        -0.9274534583091736,
        0.35997048020362854
      ],
      "plane_d": -3251.482177734375,
      "bbox_min": [
        -1958.299072265625,
        -3328.10009765625,
        860.0
      ],
      "bbox_max": [
        -1356.0,
        -3037.23291015625,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.23221024870872498,
        -0.8293224573135376,
        0.5082348585128784
      ],
      "plane_d": -2908.64794921875,
      "bbox_min": [
        -1958.299072265625,
        -3316.649169921875,
        860.0
      ],
      "bbox_max": [
        -1356.0,
        -3037.23291015625,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1356.0,
      "bbox_min": [
        -1356.0,
        -3316.649169921875,
        860.0
      ],
      "bbox_max": [
        -1356.0,
        -3315.0,
        864.300537109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.22038745880126953,
        -0.8264544606208801,
        0.5180755853652954
      ],
      "plane_d": -2934.9130859375,
      "bbox_min": [
        -1827.325927734375,
        -3194.546630859375,
        1208.92919921875
      ],
      "bbox_max": [
        -1454.6273193359375,
        -3037.23291015625,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3377978503704071,
        -0.8362663984298706,
        0.4319157302379608
      ],
      "plane_d": -2702.277587890625,
      "bbox_min": [
        -1498.3060302734375,
        -3194.546630859375,
        1208.92919921875
      ],
      "bbox_max": [
        -1454.6273193359375,
        -3159.594970703125,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.21603241562843323,
        -0.9093504548072815,
        0.35554423928260803
      ],
      "plane_d": -2994.511962890625,
      "bbox_min": [
        -1951.966796875,
        -3328.10009765625,
        929.8560791015625
      ],
      "bbox_max": [
        -1678.0,
        -3140.44775390625,
        1490.3951416015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.22038745880126953,
        -0.8264544606208801,
        0.5180755853652954
      ],
      "plane_d": -2934.9130859375,
      "bbox_min": [
        -1951.966796875,
        -3187.230224609375,
        1302.5999755859375
      ],
      "bbox_max": [
        -1686.3004150390625,
        -3140.44775390625,
        1490.3951416015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.23221024870872498,
        -0.8293224573135376,
        0.5082348585128784
      ],
      "plane_d": -2908.64794921875,
      "bbox_min": [
        -1951.966796875,
        -3171.77587890625,
        1386.64892578125
      ],
      "bbox_max": [
        -1827.3253173828125,
        -3140.44775390625,
        1490.3951416015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.24250808358192444,
        -0.909406840801239,
        0.3378889858722687
      ],
      "plane_d": -2927.0478515625,
      "bbox_min": [
        -1701.595703125,
        -3195.74658203125,
        1281.837890625
      ],
      "bbox_max": [
        -1686.3004150390625,
        -3184.333984375,
        1304.4864501953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.22038745880126953,
        -0.8264544606208801,
        0.5180755853652954
      ],
      "plane_d": -2934.9130859375,
      "bbox_min": [
        -1701.595703125,
        -3187.5849609375,
        1302.5999755859375
      ],
      "bbox_max": [
        -1686.3004150390625,
        -3184.333984375,
        1304.4864501953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0012848323676735163,
        -0.9360799789428711,
        0.351784884929657
      ],
      "plane_d": -3417.8896484375,
      "bbox_min": [
        -2230.8291015625,
        -3458.6162109375,
        860.0
      ],
      "bbox_max": [
        -1332.0,
        -3154.940185546875,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3377978503704071,
        -0.8362663984298706,
        0.4319157302379608
      ],
      "plane_d": -2702.277587890625,
      "bbox_min": [
        -1498.3060302734375,
        -3323.10009765625,
        860.0
      ],
      "bbox_max": [
        -1332.0,
        -3163.810791015625,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1356.0,
      "bbox_min": [
        -1356.0,
        -3323.0,
        860.0
      ],
      "bbox_max": [
        -1333.5452880859375,
        -3315.0,
        898.5741577148438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3323.0,
      "bbox_min": [
        -1356.0,
        -3323.0,
        860.0
      ],
      "bbox_max": [
        -1333.5452880859375,
        -3323.0,
        878.486083984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3323.0,
      "bbox_min": [
        -1356.0,
        -3323.0,
        865.5230712890625
      ],
      "bbox_max": [
        -1332.0,
        -3315.0,
        899.7730712890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8500498533248901,
        0.5251100659370422,
        0.04092385247349739
      ],
      "plane_d": 3041.765869140625,
      "bbox_min": [
        -2230.8291015625,
        -3458.6162109375,
        860.0
      ],
      "bbox_max": [
        -1332.0,
        -3154.940185546875,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.21603241562843323,
        -0.9093504548072815,
        0.35554423928260803
      ],
      "plane_d": -2994.511962890625,
      "bbox_min": [
        -2230.8291015625,
        -3428.0,
        892.0
      ],
      "bbox_max": [
        -1513.06103515625,
        -3154.940185546875,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.23221024870872498,
        -0.8293224573135376,
        0.5082348585128784
      ],
      "plane_d": -2908.64794921875,
      "bbox_min": [
        -1948.3681640625,
        -3229.592529296875,
        1313.641357421875
      ],
      "bbox_max": [
        -1723.06787109375,
        -3154.940185546875,
        1465.1025390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.22038745880126953,
        -0.8264544606208801,
        0.5180755853652954
      ],
      "plane_d": -2934.9130859375,
      "bbox_min": [
        -1897.7884521484375,
        -3224.37646484375,
        1313.641357421875
      ],
      "bbox_max": [
        -1723.06787109375,
        -3171.775634765625,
        1386.64892578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2753306031227112,
        -0.8354538679122925,
        0.4756152629852295
      ],
      "plane_d": -2793.050048828125,
      "bbox_min": [
        -2224.197509765625,
        -3262.831787109375,
        1304.4864501953125
      ],
      "bbox_max": [
        -1701.595703125,
        -3176.007568359375,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.22038745880126953,
        -0.8264544606208801,
        0.5180755853652954
      ],
      "plane_d": -2934.9130859375,
      "bbox_min": [
        -1775.80810546875,
        -3201.28125,
        1304.4864501953125
      ],
      "bbox_max": [
        -1701.595703125,
        -3184.775634765625,
        1317.536376953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.24250808358192444,
        -0.909406840801239,
        0.3378889858722687
      ],
      "plane_d": -2927.0478515625,
      "bbox_min": [
        -2230.8291015625,
        -3428.0,
        892.0
      ],
      "bbox_max": [
        -1513.06103515625,
        -3187.230224609375,
        1505.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.22038745880126953,
        -0.8264544606208801,
        0.5180755853652954
      ],
      "plane_d": -2934.9130859375,
      "bbox_min": [
        -2230.8291015625,
        -3294.200439453125,
        1302.5999755859375
      ],
      "bbox_max": [
        -1698.49169921875,
        -3187.230224609375,
        1428.6636962890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.23221024870872498,
        -0.8293224573135376,
        0.5082348585128784
      ],
      "plane_d": -2908.64794921875,
      "bbox_min": [
        -1929.8310546875,
        -3248.052978515625,
        1302.5999755859375
      ],
      "bbox_max": [
        -1897.7880859375,
        -3224.376220703125,
        1334.817626953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2753306031227112,
        -0.8354538679122925,
        0.4756152629852295
      ],
      "plane_d": -2793.050048828125,
      "bbox_min": [
        -2230.8291015625,
        -3288.776123046875,
        1329.7178955078125
      ],
      "bbox_max": [
        -2132.0,
        -3259.64013671875,
        1428.6636962890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.01903552934527397,
        0.9815307855606079,
        -0.19035546481609344
      ],
      "plane_d": 3524.079833984375,
      "bbox_min": [
        -2104.0859375,
        -3428.0,
        892.0
      ],
      "bbox_max": [
        -1513.06103515625,
        -3248.052978515625,
        1505.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1485.0,
      "bbox_min": [
        -1627.0,
        -3428.0,
        1459.0
      ],
      "bbox_max": [
        -1538.0,
        -3337.847900390625,
        1505.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 1538.0,
      "bbox_min": [
        -1538.0,
        -3428.0,
        1485.0
      ],
      "bbox_max": [
        -1538.0,
        -3418.6376953125,
        1505.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1538.0,
      "bbox_min": [
        -1538.0,
        -3428.0,
        1459.0
      ],
      "bbox_max": [
        -1538.0,
        -3416.611572265625,
        1485.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.39672571420669556,
        0.18136583268642426,
        -0.8998417854309082
      ],
      "plane_d": 1149.486572265625,
      "bbox_min": [
        -1633.0650634765625,
        -3371.47021484375,
        1284.5732421875
      ],
      "bbox_max": [
        -1557.488037109375,
        -3333.2451171875,
        1485.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1485.0,
      "bbox_min": [
        -1627.0,
        -3340.10986328125,
        1485.0
      ],
      "bbox_max": [
        -1587.9073486328125,
        -3333.2451171875,
        1485.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3485427498817444,
        -0.8757609128952026,
        0.3340070843696594
      ],
      "plane_d": -2608.564453125,
      "bbox_min": [
        -2104.0859375,
        -3419.54296875,
        892.0
      ],
      "bbox_max": [
        -1513.06103515625,
        -3248.052978515625,
        1485.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.23947833478450775,
        -0.8831087350845337,
        0.4034464955329895
      ],
      "plane_d": -2932.8583984375,
      "bbox_min": [
        -2104.0859375,
        -3315.35791015625,
        1193.728759765625
      ],
      "bbox_max": [
        -1925.2470703125,
        -3248.052978515625,
        1306.75244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.22970595955848694,
        -0.8470718264579773,
        0.4792749881744385
      ],
      "plane_d": -2933.39697265625,
      "bbox_min": [
        -2104.0859375,
        -3295.18115234375,
        1302.5999755859375
      ],
      "bbox_max": [
        -1925.2470703125,
        -3248.052978515625,
        1306.75244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.05185391753911972,
        0.9296181201934814,
        0.36485806107521057
      ],
      "plane_d": 2880.741455078125,
      "bbox_min": [
        -1805.2481689453125,
        -3419.54296875,
        892.0
      ],
      "bbox_max": [
        -1513.06103515625,
        -3293.278564453125,
        1485.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2235765904188156,
        0.04341130331158638,
        0.9737191796302795
      ],
      "plane_d": -385.780029296875,
      "bbox_min": [
        -1694.455078125,
        -3373.380126953125,
        929.8560791015625
      ],
      "bbox_max": [
        -1669.7366943359375,
        -3370.65771484375,
        935.5919189453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 915.0,
      "bbox_min": [
        -1523.589599609375,
        -3413.899169921875,
        892.0
      ],
      "bbox_max": [
        -1513.06103515625,
        -3411.5,
        915.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2235765904188156,
        0.04341130331158638,
        0.9737191796302795
      ],
      "plane_d": -385.780029296875,
      "bbox_min": [
        -1696.3232421875,
        -3372.009033203125,
        929.8560791015625
      ],
      "bbox_max": [
        -1669.7366943359375,
        -3370.65771484375,
        936.0020751953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.22641703486442566,
        -0.020128117874264717,
        0.9738224148750305
      ],
      "plane_d": -595.3028564453125,
      "bbox_min": [
        -1805.2481689453125,
        -3371.5869140625,
        900.3104248046875
      ],
      "bbox_max": [
        -1542.2615966796875,
        -3293.278564453125,
        1485.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.21167901158332825,
        0.041101183742284775,
        0.9764747023582458
      ],
      "plane_d": -415.9947204589844,
      "bbox_min": [
        -1805.2481689453125,
        -3371.5869140625,
        904.253662109375
      ],
      "bbox_max": [
        -1557.1119384765625,
        -3324.258544921875,
        959.013916015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.21186989545822144,
        0.07687602192163467,
        0.9742696285247803
      ],
      "plane_d": -294.561767578125,
      "bbox_min": [
        -1805.2481689453125,
        -3371.5869140625,
        929.8560791015625
      ],
      "bbox_max": [
        -1669.7366943359375,
        -3328.10009765625,
        959.013916015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2235765904188156,
        0.04341130331158638,
        0.9737191796302795
      ],
      "plane_d": -385.780029296875,
      "bbox_min": [
        -1760.14404296875,
        -3371.5869140625,
        929.8560791015625
      ],
      "bbox_max": [
        -1669.7366943359375,
        -3328.10009765625,
        950.01318359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.39672571420669556,
        0.18136583268642426,
        -0.8998417854309082
      ],
      "plane_d": 1149.486572265625,
      "bbox_min": [
        -1631.884765625,
        -3371.47021484375,
        1284.5732421875
      ],
      "bbox_max": [
        -1557.488037109375,
        -3293.278564453125,
        1485.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1485.0,
      "bbox_min": [
        -1627.0,
        -3333.9482421875,
        1485.0
      ],
      "bbox_max": [
        -1590.7506103515625,
        -3328.0,
        1485.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3184398412704468,
        0.8545205593109131,
        0.41035449504852295
      ],
      "plane_d": 2981.019287109375,
      "bbox_min": [
        -1607.613037109375,
        -3458.6162109375,
        860.0
      ],
      "bbox_max": [
        -1332.0,
        -3283.58740234375,
        1531.311767578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.05185391753911972,
        0.9296181201934814,
        0.36485806107521057
      ],
      "plane_d": 2880.741455078125,
      "bbox_min": [
        -1557.0653076171875,
        -3426.5,
        884.6555786132812
      ],
      "bbox_max": [
        -1370.0,
        -3342.51416015625,
        1032.5123291015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3411.5,
      "bbox_min": [
        -1514.9678955078125,
        -3426.5,
        892.0
      ],
      "bbox_max": [
        -1370.0,
        -3394.263916015625,
        918.5
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -894.0,
      "bbox_min": [
        -1405.0,
        -3411.5,
        894.0
      ],
      "bbox_max": [
        -1370.0,
        -3394.263916015625,
        918.5
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1401.5,
      "bbox_min": [
        -1401.5,
        -3411.5,
        894.0
      ],
      "bbox_max": [
        -1373.0,
        -3395.568115234375,
        918.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1399.5,
      "bbox_min": [
        -1401.5,
        -3411.5,
        894.0
      ],
      "bbox_max": [
        -1373.0,
        -3396.313720703125,
        918.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6585046052932739,
        0.0,
        0.7525767087936401
      ],
      "plane_d": -1611.501953125,
      "bbox_min": [
        -1401.5,
        -3410.0,
        915.0
      ],
      "bbox_max": [
        -1399.5,
        -3405.65283203125,
        916.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": 3409.999755859375,
      "bbox_min": [
        -1399.5,
        -3411.5,
        894.0
      ],
      "bbox_max": [
        -1373.0,
        -3396.5,
        918.5
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1392.5,
      "bbox_min": [
        -1392.5,
        -3411.5,
        894.0
      ],
      "bbox_max": [
        -1382.0,
        -3410.0,
        908.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1382.0,
      "bbox_min": [
        -1392.5,
        -3411.5,
        894.0
      ],
      "bbox_max": [
        -1382.0,
        -3410.0,
        908.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 908.0,
      "bbox_min": [
        -1392.5,
        -3411.5,
        908.0
      ],
      "bbox_max": [
        -1382.0,
        -3410.0,
        908.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1375.0,
      "bbox_min": [
        -1399.5,
        -3410.0,
        894.0
      ],
      "bbox_max": [
        -1373.0,
        -3396.5,
        918.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1373.0,
      "bbox_min": [
        -1373.0,
        -3410.0,
        894.0
      ],
      "bbox_max": [
        -1373.0,
        -3406.18896484375,
        901.936279296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1396.5,
      "bbox_min": [
        -1399.5,
        -3410.0,
        894.0
      ],
      "bbox_max": [
        -1392.41162109375,
        -3396.5,
        918.5
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3403.0,
      "bbox_min": [
        -1399.5,
        -3410.0,
        894.0
      ],
      "bbox_max": [
        -1396.5,
        -3396.5,
        918.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5547001957893372,
        -0.0,
        0.8320503234863281
      ],
      "plane_d": 19.96917724609375,
      "bbox_min": [
        -1399.5,
        -3410.0,
        895.0
      ],
      "bbox_max": [
        -1396.5,
        -3403.5166015625,
        918.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1399.0,
      "bbox_min": [
        -1399.0,
        -3408.5,
        895.0
      ],
      "bbox_max": [
        -1396.5,
        -3404.0,
        905.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3408.5,
      "bbox_min": [
        -1399.0,
        -3408.5,
        895.0
      ],
      "bbox_max": [
        -1396.5,
        -3404.0,
        905.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3404.0,
      "bbox_min": [
        -1399.0,
        -3408.5,
        895.0
      ],
      "bbox_max": [
        -1396.5,
        -3404.0,
        905.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 905.0,
      "bbox_min": [
        -1399.0,
        -3408.5,
        895.0
      ],
      "bbox_max": [
        -1396.5,
        -3404.0,
        905.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -895.0,
      "bbox_min": [
        -1399.0,
        -3408.5,
        895.0
      ],
      "bbox_max": [
        -1396.5,
        -3404.0,
        895.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.0,
        -0.7071068286895752
      ],
      "plane_d": 1636.5987548828125,
      "bbox_min": [
        -1399.5,
        -3410.0,
        915.0
      ],
      "bbox_max": [
        -1396.5,
        -3406.398193359375,
        918.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6585046052932739,
        0.0,
        0.7525767087936401
      ],
      "plane_d": -1611.501953125,
      "bbox_min": [
        -1399.5,
        -3410.0,
        916.75
      ],
      "bbox_max": [
        -1397.5,
        -3407.23828125,
        918.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 917.0,
      "bbox_min": [
        -1397.5,
        -3410.0,
        917.0
      ],
      "bbox_max": [
        -1396.5,
        -3408.103759765625,
        917.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1399.0,
      "bbox_min": [
        -1399.5,
        -3403.0,
        894.0
      ],
      "bbox_max": [
        -1396.5,
        -3396.5,
        905.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3396.5,
      "bbox_min": [
        -1399.5,
        -3396.5,
        894.0
      ],
      "bbox_max": [
        -1398.9993896484375,
        -3396.5,
        894.3884887695312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -895.0,
      "bbox_min": [
        -1399.0,
        -3403.0,
        895.0
      ],
      "bbox_max": [
        -1396.5,
        -3398.5,
        905.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3398.5,
      "bbox_min": [
        -1399.0,
        -3403.0,
        895.0
      ],
      "bbox_max": [
        -1396.5,
        -3398.5,
        905.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 905.0,
      "bbox_min": [
        -1399.0,
        -3403.0,
        905.0
      ],
      "bbox_max": [
        -1396.5,
        -3401.7822265625,
        905.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 917.0,
      "bbox_min": [
        -1396.5,
        -3410.0,
        917.0
      ],
      "bbox_max": [
        -1392.41162109375,
        -3408.476318359375,
        917.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 915.0,
      "bbox_min": [
        -1514.9678955078125,
        -3426.5,
        892.0
      ],
      "bbox_max": [
        -1380.0,
        -3411.5,
        915.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -892.0,
      "bbox_min": [
        -1513.8607177734375,
        -3426.5,
        892.0
      ],
      "bbox_max": [
        -1380.0,
        -3411.5,
        915.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3426.5,
      "bbox_min": [
        -1460.416748046875,
        -3426.5,
        892.0
      ],
      "bbox_max": [
        -1380.0,
        -3411.5,
        915.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1380.0,
      "bbox_min": [
        -1380.0,
        -3426.5,
        892.0
      ],
      "bbox_max": [
        -1380.0,
        -3411.5,
        915.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.22641703486442566,
        -0.020128117874264717,
        0.9738224148750305
      ],
      "plane_d": -595.3028564453125,
      "bbox_min": [
        -1557.0653076171875,
        -3366.172119140625,
        884.6555786132812
      ],
      "bbox_max": [
        -1474.71875,
        -3342.51416015625,
        904.2412719726562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9726229310035706,
        0.20830567181110382,
        -0.10302186012268066
      ],
      "plane_d": 2349.484130859375,
      "bbox_min": [
        -1607.613037109375,
        -3458.6162109375,
        860.0
      ],
      "bbox_max": [
        -1332.0,
        -3283.58740234375,
        1531.311767578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9593862891197205,
        0.24561771750450134,
        -0.13874416053295135
      ],
      "plane_d": 2500.552490234375,
      "bbox_min": [
        -1607.613037109375,
        -3420.196533203125,
        1284.5732421875
      ],
      "bbox_max": [
        -1538.0,
        -3283.58740234375,
        1531.311767578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.39672571420669556,
        0.18136583268642426,
        -0.8998417854309082
      ],
      "plane_d": 1149.486572265625,
      "bbox_min": [
        -1607.613037109375,
        -3420.196533203125,
        1284.5732421875
      ],
      "bbox_max": [
        -1538.0,
        -3287.91259765625,
        1531.311767578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1547.0,
      "bbox_min": [
        -1563.4188232421875,
        -3420.196533203125,
        1485.0
      ],
      "bbox_max": [
        -1538.0,
        -3322.5078125,
        1531.311767578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999086856842041,
        -0.0,
        0.013512278907001019
      ],
      "plane_d": 1531.751953125,
      "bbox_min": [
        -1563.4188232421875,
        -3387.0,
        1485.0
      ],
      "bbox_max": [
        -1547.0,
        -3322.5078125,
        1531.311767578125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.5300086140632629,
        -6.929040864633862e-06,
        -0.8479923605918884
      ],
      "plane_d": 469.89190673828125,
      "bbox_min": [
        -1563.4188232421875,
        -3384.9921875,
        1525.0
      ],
      "bbox_max": [
        -1552.5,
        -3322.5078125,
        1531.311767578125
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.847313404083252,
        0.03997046872973442,
        -0.5295870304107666
      ],
      "plane_d": 2260.09765625,
      "bbox_min": [
        -1554.93896484375,
        -3384.9921875,
        1525.0
      ],
      "bbox_max": [
        -1552.5,
        -3322.5078125,
        1526.8118896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.847313404083252,
        -0.03997046872973442,
        -0.5295870304107666
      ],
      "plane_d": 1990.376953125,
      "bbox_min": [
        -1554.93896484375,
        -3384.9921875,
        1525.7999267578125
      ],
      "bbox_max": [
        -1554.099853515625,
        -3375.0,
        1526.8118896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.847313404083252,
        -0.03997046872973442,
        -0.5295870304107666
      ],
      "plane_d": 1991.995849609375,
      "bbox_min": [
        -1554.93896484375,
        -3344.4921875,
        1525.0
      ],
      "bbox_max": [
        -1552.5,
        -3322.5078125,
        1526.8118896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.847313404083252,
        0.03997046872973442,
        -0.5295870304107666
      ],
      "plane_d": 2258.478759765625,
      "bbox_min": [
        -1554.93896484375,
        -3332.5,
        1525.7999267578125
      ],
      "bbox_max": [
        -1554.099853515625,
        -3322.5078125,
        1526.8118896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3334.5,
      "bbox_min": [
        -1554.5999755859375,
        -3334.5,
        1525.0
      ],
      "bbox_max": [
        -1552.5,
        -3334.5,
        1526.60009765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3334.5,
      "bbox_min": [
        -1554.5999755859375,
        -3334.5,
        1525.0
      ],
      "bbox_max": [
        -1553.3206787109375,
        -3334.5,
        1525.7999267578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6401844024658203,
        0.768221378326416,
        -0.0
      ],
      "plane_d": 3592.3310546875,
      "bbox_min": [
        -1550.0,
        -3387.0,
        1485.0
      ],
      "bbox_max": [
        -1547.0,
        -3384.5,
        1505.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 1538.0,
      "bbox_min": [
        -1547.0,
        -3420.196533203125,
        1485.0
      ],
      "bbox_max": [
        -1538.0,
        -3387.0,
        1505.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6401844024658203,
        0.768221378326416,
        -0.0
      ],
      "plane_d": 3592.3310546875,
      "bbox_min": [
        -1547.0,
        -3394.5,
        1485.0
      ],
      "bbox_max": [
        -1538.0,
        -3387.0,
        1505.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1538.0,
      "bbox_min": [
        -1550.0,
        -3418.6376953125,
        1459.0
      ],
      "bbox_max": [
        -1538.0,
        -3329.5,
        1485.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6401844024658203,
        0.768221378326416,
        0.0
      ],
      "plane_d": 3592.3310546875,
      "bbox_min": [
        -1550.0,
        -3394.5,
        1459.0
      ],
      "bbox_max": [
        -1538.0,
        -3329.5,
        1485.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1548.5,
      "bbox_min": [
        -1548.5,
        -3333.5,
        1482.0
      ],
      "bbox_max": [
        -1548.5,
        -3329.5,
        1485.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.982089102268219,
        0.1529073566198349,
        -0.11009181290864944
      ],
      "plane_d": 2186.53564453125,
      "bbox_min": [
        -1568.4244384765625,
        -3458.6162109375,
        860.0
      ],
      "bbox_max": [
        -1332.0,
        -3293.638427734375,
        1460.8280029296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9593862891197205,
        0.24561771750450134,
        -0.13874416053295135
      ],
      "plane_d": 2500.552490234375,
      "bbox_min": [
        -1565.24267578125,
        -3371.47021484375,
        1284.5732421875
      ],
      "bbox_max": [
        -1546.74609375,
        -3293.638427734375,
        1458.8660888671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.046494390815496445,
        0.7289436459541321,
        0.6829929947853088
      ],
      "plane_d": 1916.369873046875,
      "bbox_min": [
        -1568.4244384765625,
        -3458.6162109375,
        860.0
      ],
      "bbox_max": [
        -1332.0,
        -3315.0,
        976.6000366210938
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3368.0,
      "bbox_min": [
        -1405.0,
        -3413.664794921875,
        860.0
      ],
      "bbox_max": [
        -1332.0,
        -3366.0,
        918.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -894.0,
      "bbox_min": [
        -1405.0,
        -3413.664794921875,
        860.0
      ],
      "bbox_max": [
        -1332.0,
        -3368.0,
        918.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3374.0,
      "bbox_min": [
        -1356.0,
        -3374.0,
        860.0
      ],
      "bbox_max": [
        -1332.0,
        -3368.0,
        887.46484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1356.0,
      "bbox_min": [
        -1356.0,
        -3374.0,
        860.0
      ],
      "bbox_max": [
        -1356.0,
        -3368.0,
        887.46484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1373.0,
      "bbox_min": [
        -1401.5,
        -3413.664794921875,
        894.0
      ],
      "bbox_max": [
        -1373.0,
        -3377.220947265625,
        918.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1375.0,
      "bbox_min": [
        -1401.5,
        -3413.664794921875,
        894.0
      ],
      "bbox_max": [
        -1375.0,
        -3377.220947265625,
        918.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1401.5,
      "bbox_min": [
        -1401.5,
        -3413.664794921875,
        894.0
      ],
      "bbox_max": [
        -1375.0,
        -3377.220947265625,
        918.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1399.5,
      "bbox_min": [
        -1401.5,
        -3413.664794921875,
        894.0
      ],
      "bbox_max": [
        -1375.0,
        -3377.348388671875,
        918.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6585046052932739,
        0.0,
        0.7525767087936401
      ],
      "plane_d": -1611.501953125,
      "bbox_min": [
        -1401.5,
        -3407.23828125,
        915.0
      ],
      "bbox_max": [
        -1399.5,
        -3396.897216796875,
        916.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 915.0,
      "bbox_min": [
        -1399.5,
        -3413.664794921875,
        894.0
      ],
      "bbox_max": [
        -1375.0,
        -3385.0,
        918.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 917.0,
      "bbox_min": [
        -1399.5,
        -3410.0,
        915.0
      ],
      "bbox_max": [
        -1375.0,
        -3397.024658203125,
        918.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6585046052932739,
        0.0,
        0.7525767087936401
      ],
      "plane_d": -1611.501953125,
      "bbox_min": [
        -1399.2142333984375,
        -3408.823974609375,
        917.0
      ],
      "bbox_max": [
        -1397.5,
        -3398.9169921875,
        918.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": -3403.499755859375,
      "bbox_min": [
        -1399.5,
        -3410.0,
        915.0
      ],
      "bbox_max": [
        -1375.0,
        -3397.024658203125,
        917.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": 3401.499755859375,
      "bbox_min": [
        -1399.5,
        -3403.5,
        915.0
      ],
      "bbox_max": [
        -1375.0,
        -3397.024658203125,
        917.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.0,
        -0.7071068286895752
      ],
      "plane_d": 1636.5987548828125,
      "bbox_min": [
        -1399.5,
        -3403.5,
        915.0
      ],
      "bbox_max": [
        -1375.0,
        -3401.5,
        917.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6585046052932739,
        0.0,
        0.7525767087936401
      ],
      "plane_d": -1611.501953125,
      "bbox_min": [
        -1399.5,
        -3403.5,
        916.75
      ],
      "bbox_max": [
        -1399.2142333984375,
        -3401.5,
        917.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.0,
        -0.7071068286895752
      ],
      "plane_d": -325.2691650390625,
      "bbox_min": [
        -1377.0,
        -3403.5,
        915.0
      ],
      "bbox_max": [
        -1375.0,
        -3401.5,
        917.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.0,
        -0.7071068286895752
      ],
      "plane_d": 1636.5987548828125,
      "bbox_min": [
        -1399.5,
        -3401.5,
        915.0
      ],
      "bbox_max": [
        -1375.0,
        -3397.024658203125,
        917.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6585046052932739,
        0.0,
        0.7525767087936401
      ],
      "plane_d": -1611.501953125,
      "bbox_min": [
        -1399.5,
        -3401.5,
        916.75
      ],
      "bbox_max": [
        -1399.2142333984375,
        -3398.66455078125,
        917.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.0,
        -0.7071068286895752
      ],
      "plane_d": -325.2691650390625,
      "bbox_min": [
        -1377.0,
        -3401.5,
        915.0
      ],
      "bbox_max": [
        -1375.0,
        -3398.58740234375,
        917.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": 3409.999755859375,
      "bbox_min": [
        -1399.5,
        -3410.0,
        915.0
      ],
      "bbox_max": [
        -1375.0,
        -3403.5,
        917.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.0,
        -0.7071068286895752
      ],
      "plane_d": -325.2691650390625,
      "bbox_min": [
        -1399.5,
        -3410.0,
        915.0
      ],
      "bbox_max": [
        -1375.0,
        -3403.5,
        917.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.0,
        -0.7071068286895752
      ],
      "plane_d": 1636.5987548828125,
      "bbox_min": [
        -1399.5,
        -3408.103759765625,
        915.0
      ],
      "bbox_max": [
        -1397.5,
        -3403.5,
        917.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6585046052932739,
        0.0,
        0.7525767087936401
      ],
      "plane_d": -1611.501953125,
      "bbox_min": [
        -1399.5,
        -3407.46484375,
        916.75
      ],
      "bbox_max": [
        -1399.2142333984375,
        -3403.5,
        917.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        -0.0
      ],
      "plane_d": 3409.999755859375,
      "bbox_min": [
        -1399.5,
        -3413.664794921875,
        894.0
      ],
      "bbox_max": [
        -1375.0,
        -3385.0,
        915.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3411.5,
      "bbox_min": [
        -1385.80908203125,
        -3413.664794921875,
        910.4920043945312
      ],
      "bbox_max": [
        -1380.0,
        -3411.5,
        915.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1380.0,
      "bbox_min": [
        -1380.0,
        -3413.664794921875,
        910.4920043945312
      ],
      "bbox_max": [
        -1380.0,
        -3411.5,
        915.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9615239500999451,
        -0.0,
        -0.2747211158275604
      ],
      "plane_d": -1074.57177734375,
      "bbox_min": [
        -1399.5,
        -3403.674072265625,
        894.0
      ],
      "bbox_max": [
        -1375.0,
        -3385.0,
        915.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3398.5,
      "bbox_min": [
        -1379.0,
        -3398.5,
        904.5
      ],
      "bbox_max": [
        -1375.0,
        -3388.685546875,
        915.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 904.5,
      "bbox_min": [
        -1376.0,
        -3398.5,
        904.5
      ],
      "bbox_max": [
        -1375.0,
        -3388.685546875,
        904.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6000000238418579,
        0.0,
        0.800000011920929
      ],
      "plane_d": -1545.2000732421875,
      "bbox_min": [
        -1399.5,
        -3403.674072265625,
        894.0
      ],
      "bbox_max": [
        -1375.0,
        -3385.0,
        909.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1379.0,
      "bbox_min": [
        -1379.5999755859375,
        -3397.0,
        894.0
      ],
      "bbox_max": [
        -1375.0,
        -3385.0,
        899.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3397.0,
      "bbox_min": [
        -1379.0,
        -3397.0,
        894.0
      ],
      "bbox_max": [
        -1375.0,
        -3385.0,
        899.7999877929688
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3385.0,
      "bbox_min": [
        -1379.0,
        -3385.0,
        894.0
      ],
      "bbox_max": [
        -1375.0,
        -3385.0,
        899.7999877929688
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8000073432922363,
        -0.0,
        -0.5999902486801147
      ],
      "plane_d": -565.6188354492188,
      "bbox_min": [
        -1379.5999755859375,
        -3397.0,
        896.0
      ],
      "bbox_max": [
        -1379.0,
        -3385.0,
        897.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3397.0,
      "bbox_min": [
        -1379.5999755859375,
        -3397.0,
        896.0
      ],
      "bbox_max": [
        -1379.0,
        -3385.0,
        897.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3385.0,
      "bbox_min": [
        -1379.5999755859375,
        -3385.0,
        896.0
      ],
      "bbox_max": [
        -1379.0,
        -3385.0,
        897.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3396.5,
      "bbox_min": [
        -1399.5,
        -3403.674072265625,
        894.0
      ],
      "bbox_max": [
        -1379.5999755859375,
        -3385.0,
        909.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1396.5,
      "bbox_min": [
        -1399.5,
        -3403.674072265625,
        894.0
      ],
      "bbox_max": [
        -1379.5999755859375,
        -3396.5,
        909.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.5547001957893372,
        -0.0,
        0.8320503234863281
      ],
      "plane_d": 19.96917724609375,
      "bbox_min": [
        -1399.5,
        -3403.674072265625,
        896.2250366210938
      ],
      "bbox_max": [
        -1396.5,
        -3396.5,
        909.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3398.5,
      "bbox_min": [
        -1399.0,
        -3402.714111328125,
        896.2250366210938
      ],
      "bbox_max": [
        -1396.5,
        -3398.5,
        905.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1399.0,
      "bbox_min": [
        -1399.0,
        -3402.714111328125,
        898.1651611328125
      ],
      "bbox_max": [
        -1396.5,
        -3398.5,
        905.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 905.0,
      "bbox_min": [
        -1399.0,
        -3402.714111328125,
        905.0
      ],
      "bbox_max": [
        -1396.5,
        -3398.5,
        905.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1379.5999755859375,
      "bbox_min": [
        -1379.5999755859375,
        -3397.0,
        896.7999877929688
      ],
      "bbox_max": [
        -1379.5999755859375,
        -3396.5,
        898.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1379.5999755859375,
      "bbox_min": [
        -1379.5999755859375,
        -3396.5,
        896.7999877929688
      ],
      "bbox_max": [
        -1379.5999755859375,
        -3385.0,
        898.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1356.0,
      "bbox_min": [
        -1356.0,
        -3368.0,
        860.0
      ],
      "bbox_max": [
        -1356.0,
        -3366.0,
        881.0611572265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.05163498595356941,
        -0.004590269178152084,
        0.9986554980278015
      ],
      "plane_d": -822.7598266601562,
      "bbox_min": [
        -1568.4244384765625,
        -3400.431640625,
        878.1983032226562
      ],
      "bbox_max": [
        -1335.0635986328125,
        -3315.0,
        918.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.05333402752876282,
        0.0,
        0.9985767602920532
      ],
      "plane_d": -804.9474487304688,
      "bbox_min": [
        -1470.9000244140625,
        -3365.699951171875,
        878.1983032226562
      ],
      "bbox_max": [
        -1350.0,
        -3320.83935546875,
        884.6555786132812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3323.0,
      "bbox_min": [
        -1356.0,
        -3323.0,
        878.4837036132812
      ],
      "bbox_max": [
        -1355.343994140625,
        -3322.98779296875,
        878.5187377929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1356.0,
      "bbox_min": [
        -1356.0,
        -3323.0,
        878.486083984375
      ],
      "bbox_max": [
        -1356.0,
        -3322.98779296875,
        878.5187377929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3323.0,
      "bbox_min": [
        -1356.0,
        -3323.0,
        878.4694213867188
      ],
      "bbox_max": [
        -1351.4473876953125,
        -3322.917724609375,
        878.7052001953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1356.0,
      "bbox_min": [
        -1356.0,
        -3323.0,
        878.5187377929688
      ],
      "bbox_max": [
        -1356.0,
        -3322.917724609375,
        878.7052001953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.21167901158332825,
        0.041101183742284775,
        0.9764747023582458
      ],
      "plane_d": -415.9947204589844,
      "bbox_min": [
        -1568.4244384765625,
        -3400.431640625,
        878.4094848632812
      ],
      "bbox_max": [
        -1335.0635986328125,
        -3315.0,
        918.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.22641703486442566,
        -0.020128117874264717,
        0.9738224148750305
      ],
      "plane_d": -595.3028564453125,
      "bbox_min": [
        -1557.1119384765625,
        -3363.79541015625,
        884.6555786132812
      ],
      "bbox_max": [
        -1470.9000244140625,
        -3320.83935546875,
        904.253662109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1356.0,
      "bbox_min": [
        -1356.0,
        -3323.0,
        878.704833984375
      ],
      "bbox_max": [
        -1356.0,
        -3315.0,
        912.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3368.0,
      "bbox_min": [
        -1405.0,
        -3400.431640625,
        878.9266357421875
      ],
      "bbox_max": [
        -1337.6041259765625,
        -3366.0,
        918.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -894.0,
      "bbox_min": [
        -1405.0,
        -3400.431640625,
        881.0611572265625
      ],
      "bbox_max": [
        -1337.6041259765625,
        -3368.0,
        918.5
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3374.0,
      "bbox_min": [
        -1356.0,
        -3374.0,
        881.0611572265625
      ],
      "bbox_max": [
        -1337.6041259765625,
        -3368.0,
        894.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1356.0,
      "bbox_min": [
        -1356.0,
        -3374.0,
        881.0611572265625
      ],
      "bbox_max": [
        -1356.0,
        -3368.0,
        894.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1373.0,
      "bbox_min": [
        -1401.5,
        -3400.431640625,
        894.0
      ],
      "bbox_max": [
        -1340.1395263671875,
        -3368.0,
        918.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1401.5,
      "bbox_min": [
        -1401.5,
        -3400.431640625,
        894.0
      ],
      "bbox_max": [
        -1373.0,
        -3374.5,
        918.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 917.0,
      "bbox_min": [
        -1401.5,
        -3400.431640625,
        894.0
      ],
      "bbox_max": [
        -1373.0,
        -3374.5,
        918.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6585046052932739,
        0.0,
        0.7525767087936401
      ],
      "plane_d": -1611.501953125,
      "bbox_min": [
        -1399.2142333984375,
        -3400.431640625,
        917.0
      ],
      "bbox_max": [
        -1375.2857666015625,
        -3374.5,
        918.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3374.5,
      "bbox_min": [
        -1399.2142333984375,
        -3374.5,
        917.0
      ],
      "bbox_max": [
        -1375.2857666015625,
        -3374.5,
        918.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1375.0,
      "bbox_min": [
        -1401.5,
        -3400.333740234375,
        894.0
      ],
      "bbox_max": [
        -1373.0,
        -3374.5,
        917.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3374.5,
      "bbox_min": [
        -1375.0,
        -3374.5,
        894.0
      ],
      "bbox_max": [
        -1373.0,
        -3374.5,
        916.7499389648438
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1399.5,
      "bbox_min": [
        -1401.5,
        -3400.333740234375,
        894.0
      ],
      "bbox_max": [
        -1375.0,
        -3374.5,
        917.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6585046052932739,
        0.0,
        0.7525767087936401
      ],
      "plane_d": -1611.501953125,
      "bbox_min": [
        -1401.5,
        -3398.66455078125,
        894.0
      ],
      "bbox_max": [
        -1399.5,
        -3374.5,
        916.7499389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3374.5,
      "bbox_min": [
        -1401.5,
        -3374.5,
        894.0
      ],
      "bbox_max": [
        -1399.5,
        -3374.5,
        916.7499389648438
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 915.0,
      "bbox_min": [
        -1399.5,
        -3400.333740234375,
        894.0
      ],
      "bbox_max": [
        -1375.0,
        -3374.5,
        917.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6585046052932739,
        0.0,
        0.7525767087936401
      ],
      "plane_d": -1611.501953125,
      "bbox_min": [
        -1399.5,
        -3400.333740234375,
        915.0
      ],
      "bbox_max": [
        -1375.0,
        -3374.5,
        917.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3374.5,
      "bbox_min": [
        -1399.5,
        -3400.333740234375,
        915.0
      ],
      "bbox_max": [
        -1375.0,
        -3374.5,
        917.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.0,
        -0.7071068286895752
      ],
      "plane_d": -325.2691650390625,
      "bbox_min": [
        -1399.5,
        -3400.333740234375,
        915.0
      ],
      "bbox_max": [
        -1375.0,
        -3376.0,
        917.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": -3375.999755859375,
      "bbox_min": [
        -1399.5,
        -3399.02587890625,
        915.0
      ],
      "bbox_max": [
        -1375.0,
        -3376.0,
        917.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.0,
        -0.7071068286895752
      ],
      "plane_d": 1636.5987548828125,
      "bbox_min": [
        -1399.5,
        -3399.02587890625,
        915.0
      ],
      "bbox_max": [
        -1375.0,
        -3376.0,
        917.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": 3391.499755859375,
      "bbox_min": [
        -1399.5,
        -3393.5,
        915.0
      ],
      "bbox_max": [
        -1375.0,
        -3381.5,
        917.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": -3393.499755859375,
      "bbox_min": [
        -1399.5,
        -3393.5,
        915.0
      ],
      "bbox_max": [
        -1375.0,
        -3393.5,
        917.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": -3383.499755859375,
      "bbox_min": [
        -1399.5,
        -3383.5,
        915.0
      ],
      "bbox_max": [
        -1375.0,
        -3381.5,
        917.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": 3381.499755859375,
      "bbox_min": [
        -1399.5,
        -3381.5,
        915.0
      ],
      "bbox_max": [
        -1375.0,
        -3381.5,
        917.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3376.0,
      "bbox_min": [
        -1399.5,
        -3398.5,
        894.0
      ],
      "bbox_max": [
        -1375.0,
        -3374.5,
        915.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3374.5,
      "bbox_min": [
        -1399.5,
        -3376.0,
        894.0
      ],
      "bbox_max": [
        -1375.0,
        -3374.5,
        915.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1395.0,
      "bbox_min": [
        -1395.0,
        -3376.0,
        894.0
      ],
      "bbox_max": [
        -1385.0,
        -3374.5,
        908.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1385.0,
      "bbox_min": [
        -1395.0,
        -3376.0,
        894.0
      ],
      "bbox_max": [
        -1385.0,
        -3374.5,
        908.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 908.0,
      "bbox_min": [
        -1395.0,
        -3376.0,
        908.0
      ],
      "bbox_max": [
        -1385.0,
        -3374.5,
        908.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9615239500999451,
        -0.0,
        -0.2747211158275604
      ],
      "plane_d": -1074.57177734375,
      "bbox_min": [
        -1379.0,
        -3398.5,
        904.5
      ],
      "bbox_max": [
        -1375.0,
        -3384.0,
        915.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3384.0,
      "bbox_min": [
        -1379.0,
        -3398.5,
        904.5
      ],
      "bbox_max": [
        -1375.0,
        -3384.0,
        915.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 904.5,
      "bbox_min": [
        -1376.3701171875,
        -3398.5,
        904.5
      ],
      "bbox_max": [
        -1375.0,
        -3384.0,
        915.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3398.5,
      "bbox_min": [
        -1376.3701171875,
        -3398.5,
        914.9066772460938
      ],
      "bbox_max": [
        -1375.0,
        -3398.5,
        915.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3374.0,
      "bbox_min": [
        -1356.0,
        -3374.0,
        894.0
      ],
      "bbox_max": [
        -1340.1395263671875,
        -3368.0,
        912.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1356.0,
      "bbox_min": [
        -1356.0,
        -3374.0,
        894.0
      ],
      "bbox_max": [
        -1356.0,
        -3368.0,
        912.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1356.0,
      "bbox_min": [
        -1356.0,
        -3368.0,
        878.9266357421875
      ],
      "bbox_max": [
        -1356.0,
        -3366.0,
        912.0
      ],
      "face_count": 1
    }
  ],
  "placed_objects": [],
  "tutorial_messages": []
}